<template>
    <div>
        <div class="simple-form " v-if="contract.version>1">
            <div class="form-group center">
                <div class="form-label">
                    <label>变更前合同名称：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ prevChangeContract.title }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>变更前合同编号：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ prevChangeContract.sndPartyHtBh }}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>合同信息</span>
            <div class="fr clearfix">
<!--                <button v-if="contract.id != null && contract.confirmed && contractType != servcDlgt.value" class="swb-btn swb-btn-mini mr15" @click.stop="toTradeVoucherList">-->
<!--                    <span>支付管理</span>-->
<!--                </button>-->
                <button v-if="contract.id != null && contract.confirmed && contractType != servcDlgt.value" class="swb-btn swb-btn-mini mr15" @click.stop="toRcvVoucherList">
                    <span>收款明细</span>
                </button>
                <button v-if="contract.id != null" class="swb-btn swb-btn-mini mr15" @click.stop="showContractRecord">合同操作记录</button>
                <button v-if="contract.id != null && contract.confirmed && contractType != servcDlgt.value" class="swb-btn swb-btn-mini mr15" @click.stop="monitoringData">
                    <span>合同数据监控</span>
                </button>
            </div>

            <div class="fr clearfix" v-if="contract.fulfillApplyState != 0">
                <span class="mr15 font14">
                    <label>验收完成审核:</label>
                    <span v-if="contract.checkAuditState == 0">未审核</span>
                    <span v-if="contract.checkAuditState == 1">审核通过</span>
                    <span v-if="contract.checkAuditState == -1">审核未通过</span>
                </span>
                <span class="mr15 font14">
                    <label>验收完成申请:</label>
                    <span v-if="contract.checkApplyState == 0">未申请</span>
                    <span v-if="contract.checkApplyState == 1">已申请</span>
                    <span v-if="contract.checkApplyState == 2">已处理</span>
                </span>
                <span class="mr15 font14">
                    <label>履约完成审核:</label>
                    <span v-if="contract.fulfillAuditState == 0">未审核</span>
                    <span v-if="contract.fulfillAuditState == 1">审核通过</span>
                    <span v-if="contract.fulfillAuditState == -1">审核未通过</span>
                </span>
                <span class="mr15 font14">
                    <label>履约完成申请:</label>
                    <span v-if="contract.fulfillApplyState == 0">未申请</span>
                    <span v-if="contract.fulfillApplyState == 1">已申请</span>
                    <span v-if="contract.fulfillApplyState == 2">已处理</span>
                </span>
            </div>
        </div>


        <el-form :model="contract" :rules="contractRules" ref="contract" class="demo-ruleForm">
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">{{ srcMerchant }}名称</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="sndPartyName">
                            <el-input :disabled="true" v-model="contract.sndPartyName"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">卖方公司</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input :disabled="true" v-model="contract.sndPartyRealComName"></el-input>
                        <div v-if="operateContract !='chakan'" class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectRealCom(false)"></div>
                    </div>
                </div>

                <div class="form-group center" v-if="operateContract=='chakan'">
                    <div class="form-label">
                        <label>原始系统合同编号</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="originalNo">
                            <el-input :disabled="true" v-model="contract.originalNo"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="operateContract=='chakan'">
                    <div class="form-label">
                        <label>{{ sndMerchant }}签署人</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="fstPartySigner">
                            <el-input :disabled="true" v-model="contract.fstPartySigner"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">合同种类</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-radio-group :disabled="contract.id != null" v-model="contract.kindId" @change="kindChange">
                            <el-radio :label="0">标准合同</el-radio>
                            <el-radio :label="1">框架合同</el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="form-group center" v-if="isLegacyContract">
                    <div class="form-label">
                        <label class="required">线下合同</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-radio-group :disabled="contract.id != null" v-model="contract.offline">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">合同名称</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="title">
                            <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.title"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center" v-if="operateContract=='chakan'">
                    <div class="form-label">
                        <label>{{ sndMerchant }}确认时间</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="fstPartyConfirmTime">
                            <el-input :disabled="true" v-model="contract.fstPartyConfirmTime"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <!--<div class="form-group center">-->
                <!--<div class="form-label">-->
                <!--<label>自用合同编号</label>-->
                <!--</div>-->
                <!--<div class="form-value width-2x">-->
                <!--<el-form-item prop="sndPartyHtBh">-->
                <!--<el-input :disabled="operateContract=='chakan'" v-model="contract.sndPartyHtBh"></el-input>-->
                <!--</el-form-item>-->
                <!--</div>-->
                <!--</div>-->

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">合同编号</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="accordHtBh">
                            <el-input
                                :disabled="operateContract=='chakan' || operateContract=='change' || (operateContract=='edit' && contract.creatorRealComId != null && scopeEntity.realComId != contract.creatorRealComId) || contract.version > 1"
                                v-model="contract.accordHtBh"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center" v-if="contractType != servcDlgt.value && contractType != servcPurch.value">
                    <div class="form-label">
                        <label class="required">跨订单结算</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-radio-group :disabled="contract.id != null" v-model="contract.settleCrossOrderAllowed" @change="settleChange">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="form-group center" v-if="contractType != servcDlgt.value">
                    <div class="form-label">
                        <label class="required">合同来源</label>
                    </div>
                    <div v-if="contractType == integPurch.value" class="form-value width-3x">
                        <el-radio-group :disabled="contract.srcId != null || contract.fstPartyId != null" v-model="contract.srcFlag">
                            <el-radio v-for="bizSrcFlag in bizSrcFlagList" v-if="bizSrcFlag.name != 'DeviceRequire' && bizSrcFlag.name != 'DealInqry' && bizSrcFlag.name != 'PriceInqry'" :label="bizSrcFlag.value">
                                <span>{{ bizSrcFlag.text }}</span>
                            </el-radio>
                        </el-radio-group>
                    </div>
                    <div class="form-value width-3x" v-else>
                        <el-radio-group :disabled="contract.srcId != null || contract.fstPartyId != null" v-model="contract.srcFlag">
                            <el-radio v-for="bizSrcFlag in bizSrcFlagList" v-if="bizSrcFlag.name != 'DeviceRequire' && bizSrcFlag.name != 'DealInqry'" :label="bizSrcFlag.value">
                                <span>{{ bizSrcFlag.text }}</span>
                            </el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="form-group center" v-if="contractType != servcDlgt.value && contract.srcFlag == 2">
                    <div class="form-label">
                        <label>投标书</label>
                    </div>
                    <div class="form-value width-2x">
                        <div class="btn-label-group" style="margin-top: 7px;overflow: inherit;">
                            <el-form-item prop="srcWinId">
                                <label class="textfield" style="width: 242px;">{{ contract.srcName }}
                                    <i v-if="operateContract!='chakan' && !disabled  && contract.srcWinId != null" class="cleared" @click="deleteCall()"></i>
                                </label>
                                <div v-if="operateContract=='change' || (contract.id == null || operateContract=='edit') && contract.fstPartyConfirmed == false" class="swb-btn swb-btn-small fl right-radio" @click="showCallBidDocDlg()">
                                    <span>选择投标书</span>
                                </div>
                                <div class="swb-btn swb-btn-small fl swb-btn-disabled right-radio" v-else>选择投标书</div>
                                <el-input type="text" style="display: none;" v-model.number="contract.srcWinId"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">{{ sndMerchant }}</label>
                    </div>
                    <div class="form-value width-2x">
                        <div class="btn-label-group" style="margin-top: 7px;overflow: inherit;">
                            <el-form-item prop="fstPartyId">
                                <label class="textfield" style="width: 242px;">{{ contract.fstPartyName }}</label>
                                <div v-if="contract.id == null" class="swb-btn swb-btn-small fl right-radio" @click="showMerchantDlg()">
                                    <span>选择{{ sndMerchant }}</span>
                                </div>
                                <div class="swb-btn swb-btn-small fl swb-btn-disabled right-radio" v-else>选择{{ sndMerchant }}</div>
                                <el-input type="text" style="display: none;" v-model.number="contract.fstPartyId"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="form-group center"> <!-- v-if="contract.kindId == 0" -->
                    <div class="form-label">
                        <label class="required">买方公司</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input :disabled="true" v-model="contract.fstPartyRealComName"></el-input>
                        <div v-if="operateContract !='chakan' && operateContract !='edit'" class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectRealCom(true)"></div>
                    </div>
                </div>

                <div class="form-group center" v-if="operateContract=='chakan'">
                    <div class="form-label">
                        <label>{{ sndMerchant }}确认人</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="fstPartyConfirmerName">
                            <el-input :disabled="true" v-model="contract.fstPartyConfirmerName"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center" v-if="contractType == servcPurch.value && contract.srcFlag == 3">
                    <div class="form-label">
                        <label>报价单</label>
                    </div>
                    <div class="form-value width-3x">
                        <div class="btn-label-group" style="margin-top: 7px;overflow: inherit;">
                            <el-form-item prop="srcWinId">
                                <label class="textfield" style="width: 242px;">{{ contract.srcName }}
                                    <i v-if="operateContract!='chakan' && !disabled && contract.srcWinId != null" class="cleared" @click="deletePrice()"></i>
                                </label>
                                <div v-if="operateContract=='change' || (contract.id == null || operateContract=='edit') && contract.fstPartyConfirmed == false && contract.fstPartyId != null" class="swb-btn swb-btn-small fl right-radio"
                                     @click="showPriceReplyDocDlg()">
                                    <span>选择报价单</span>
                                </div>
                                <div class="swb-btn swb-btn-small fl swb-btn-disabled right-radio" v-else>选择报价单</div>
                                <span class="inline-block ml10">(请先选择{{ sndMerchant }})</span>
                                <el-input type="text" style="display: none;" v-model.number="contract.srcWinId"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">签署日期</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="signDate">
                            <el-date-picker class="width-2x" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="changeSignDate" v-model="contract.signDate" type="date"
                                            placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center" v-if="operateContract=='chakan'">
                    <div class="form-label">
                        <label>否认原因</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="denyCause">
                            <el-input type="textarea" :disabled="true" v-model="contract.denyCause"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">起始时间</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="dateStart">
                            <el-date-picker class="width-2x" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.dateStart" type="date" @change="checkTime"
                                            placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">结束时间</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="dateEnd">
                            <el-date-picker class="width-2x" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.dateEnd" type="date" @change="checkTime"
                                            placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label>签署人姓名</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="sndPartySigner">
                            <el-input :disabled="operateContract=='chakan'" v-model="contract.sndPartySigner"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center" v-if="forGoods && contract.kindId == 1">
                    <div class="form-label">
                        <label>到货期限（天）</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="desireArriveDays">
                            <el-input class="width-2x" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="number" v-model="contract.desireArriveDays"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label>自用合同标签</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="sndPartyFlag">
                            <el-input type="text" :disabled="operateContract!='change' && (disabled || operateContract=='chakan')" v-model="contract.sndPartyFlag"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div v-if="contract.version>1 || operateContract=='change'" class="form-group center">
                    <div class="form-label">
                        <label>变更简要描述</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="changeDesc">
                            <el-input type="textarea" :disabled="operateContract!='change' && (disabled  || operateContract=='chakan')" v-model="contract.changeDesc"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>合同摘要</label>
                    </div>
                    <div class="form-value width-3x">
                        <el-form-item prop="content">
                            <el-input resize="none" type="textarea" :disabled="operateContract!='change' && (disabled  || operateContract=='chakan')" v-model="contract.contractDigest.content"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center" v-if="contractType == integPurch.value || contractType == servcPurch.value">
                    <div class="form-label">
                        <label class="required">税率(%)</label>
                    </div>
                    <div class="form-value width-2x">
                        <!--<el-select v-if="normalFlag" :disabled="true" v-model="contract.taxRate" filterable placeholder="请选择税率" @change="taxRateChange(contract.taxRate)">-->
                        <!--<el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>-->
                        <!--</el-select>-->
                        <el-form-item prop="taxRate"><!-- v-if="!normalFlag"-->
                            <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.taxRate" @change="taxRateChange(contract.taxRate)"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="contractType == integPurch.value">
                    <div class="form-label">
                        <label>启用区域价格</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-checkbox v-model="contract.bizAreaFlag" :disabled="true"></el-checkbox>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label>是否自动结算</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-radio-group v-model="contract.settleAutoFlag" :disabled="operateContract=='chakan'">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="form-group center" v-if="contract.settleAutoFlag">
                    <div class="form-label">
                        <label>结算周期(每月x日)</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-input-number v-model="contract.settlePeriodDay" :controls="false" :min="1" :max="28" :disabled="operateContract=='chakan'"></el-input-number>
                    </div>
                </div>
            </div>
        </el-form>

        <template v-if="contractType == integPurch.value">
            <div class="content-caption dashed">
                <span>商品信息</span>
            </div>
            <div class="simple-row">
                <div class="left">
                    <div v-if="(showBtn ===  false || disabledBtn) && operateContract!='change'">
                        <button class="swb-btn swb-btn-small swb-btn-disabled">选择商品</button>
                    </div>
                    <div v-else>
                        <button class="swb-btn swb-btn-small" @click="showMkuListDlg">选择商品</button>
                    </div>
                </div>
            </div>
            <div class="table-layout mt10">
                <el-form :model="contract" ref="contractGoodsList">
                    <el-table ref="multipleTable" :data="contract.contractGoodsList" border tooltip-effect="dark" style="width: 100%">
                        <el-table-column align="left" prop="name" label="商品名称"></el-table-column>
                        <el-table-column align="left" prop="catName" label="分类"></el-table-column>
                        <el-table-column align="left" width="100px" prop="brandName" label="品牌"></el-table-column>
                        <el-table-column align="left" prop="model" label="型号"></el-table-column>
                        <el-table-column align="left" prop="fixedSpec" label="规格"></el-table-column>
                        <el-table-column align="center" width="80px" prop="quantity" label="数量" v-if="contract.kindId == 0">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.quantity'">
                                    <el-input :maxlength="6" :disabled="(disabled || operateContract=='chakan' || scope.row.bizAreaFlag) && operateContract!='change'" type="text"
                                              @change="goodsAmountOrQuantityChange(scope.row, scope.$index, 'quantity');" v-model.number="scope.row.quantity"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="60px" prop="unit" label="单位"></el-table-column>
                        <el-table-column align="center" width="100px" prop="price" label="统一含税价(元)">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.price'">
                                    <el-input v-if="checkActionPerm('view_item_price') || operateContract!='chakan'" :maxlength="9" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="text"
                                              @change="goodsAmountOrQuantityChange(scope.row, scope.$index, 'price');" v-model="scope.row.price"></el-input>
                                    <el-input v-else disabled type="text" value="没有权限"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100px" label="税率(%)">
                            <template slot-scope="scope">
                                <span v-if="checkActionPerm('view_item_price')">{{ scope.row.taxRate }}</span>
                                <span v-else>没有权限</span>
                                <!--<el-form-item :prop="'contractGoodsList.' + scope.$index + '.taxRate'" :rules="{validator: validateTaxRate, trigger: 'blur'}">-->
                                <!--<el-input type="text" :maxlength="9" v-if="checkActionPerm('view_item_price') || operateContract!='chakan'" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="scope.row.taxRate" @change="taxRateChange(scope.row, scope.$index)"></el-input>-->
                                <!--<el-input v-else disabled type="text" value="没有权限"></el-input>-->
                                <!--</el-form-item>-->
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100px" prop="ntxPrice" label="未税价(元)">
                            <template slot-scope="scope">
                                <div v-if="checkActionPerm('view_item_price')">
                                    <span v-if="scope.row.ntxPrice != null">{{ scope.row.ntxPrice }}</span>
                                    <span v-else>0.00</span>
                                </div>
                                <div v-else>
                                    <span>没有权限</span>
                                </div>
                            </template>
                        </el-table-column>
                        <!--<el-table-column align="left" width="100px" prop="bizFormNames" label="经营业态">-->
                        <!--<template slot-scope="scope">-->
                        <!--<div v-if="scope.row.bizFormNameList != null && scope.row.bizFormNameList.length > 0" v-for="(bizFormName, index) in scope.row.bizFormNameList">-->
                        <!--<span class="swb-tags swb-tags-success mr5">{{bizFormName}}</span>-->
                        <!--</div>-->
                        <!--</template>-->
                        <!--</el-table-column>-->
                        <el-table-column align="center" width="100" label="启用区域价格">
                            <template slot-scope="scope">
                                <input v-if="checkActionPerm('view_item_price') || operateContract !='chakan'" type="checkbox" :disabled="true" v-model="scope.row.bizAreaFlag"/>
                                <span v-else>没有权限</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100px" prop="amount" label="含税小计(元)" v-if="contract.kindId == 0">
                            <template slot-scope="scope">
                                <div v-if="checkActionPerm('view_item_price')">
                                    <span v-if="scope.row.amount != null">{{ scope.row.amount }}</span>
                                    <span v-else>0.00</span>
                                </div>
                                <div v-else>
                                    <span>没有权限</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100px" prop="wrntPeriod" label="质保期(月)">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.wrntPeriod'" :rules="{validator: inputWrntPeriod, trigger: 'blur'}">
                                    <el-input :maxlength="3" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="text" v-model.number="scope.row.wrntPeriod"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100px" prop="asmblAccFlag" label="组装件">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.asmblAccFlag'">
                                    <input type="checkbox" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="scope.row.asmblAccFlag"/>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="200px" prop="desc" label="说明">
                            <template slot-scope="scope">
                                <el-form-item :prop="'contractGoodsList.' + scope.$index + '.desc'">
                                    <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="textarea" v-model="scope.row.desc"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="150px" label="操作" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <a class="swb-btn-link" @click="removeGoods(scope.$index)" v-if="showSave && contract.fstPartyConfirmed == false && contract.srcId == null">移除</a>
                                <a class="swb-btn-link" v-if="checkActionPerm('view_item_price') && scope.row.bizAreaFlag" @click="bizAreaOption(scope.row, scope.$index)">经营区域价格</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
            <div class="simple-form" v-if="contract.kindId != null && contract.kindId == 0">
                <div class="form-group center">
                    <div class="form-label">
                        <label>预计商品总件数：</label>
                    </div>
                    <div class="form-value width-2x">
                        <input :disabled="(showBtn ===  false && operateContract!='change') && showAmtAndCot" style="border:1px solid #DDDDDD; width: 65px; height: 30px;" v-model.number="contract.estmtGoodsCount"/>
                        <span>件</span>
                    </div>
                </div>
            </div>
        </template>

        <div class="content-caption dashed">
            <span>适用机构</span>
        </div>
        <el-tag class="mr5" v-for="(contractAppliedShop, index) in contract.contractAppliedShopList" :key="contractAppliedShop.shopName" type="info">
            <span>{{ contractAppliedShop.shopName }}</span>
        </el-tag>

        <div class="content-caption dashed">
            <span>设备维保服务</span>
        </div>
        <div class="table-layout mt10" style="overflow:auto">
            <el-form :model="contract" ref="contractServcList">
                <table class="custom-tbl error-prompt">
                    <thead class="head">
                    <tr class="row">
                        <th width="200" class="text-align: left;">设备维保分组</th>
                        <th width="150" class="text-align: left;">资产品牌</th>
                        <th width="150" class="text-align: left;">服务类型</th>
                        <th width="150" class="text-align: left;">商品分类</th>
                        <th width="200" class="text-align: left;">服务内容</th>
                        <th width="80" class="text-align: left;">仅部件报修</th>
                        <th width="300" class="text-align: left;">设备部件</th>
                        <th width="200" class="text-align: left;">服务项目</th>
                        <th width="140" class="text-align: right;">上门费(元)</th>
                        <th width="140" class="text-align: right;">服务费(元)</th>
                        <th width="140" class="text-align: right;">要求响应时长(分钟)</th>
                        <th width="140" class="text-align: right;">要求到达时长(分钟)</th>
                        <th width="140" class="text-align: right;">要求维修时长(分钟)</th>
                        <th width="120" class="text-align: right;">要求质保时长(天)</th>
                        <th width="140" class="text-align: right;">电话回询时限(分钟)</th>
                        <th width="200" class="text-align: right;">服务次数</th>
                        <th width="140" class="text-align: right;">服务次数允许修订</th>
                        <th width="140" class="text-align: right;">小计(元)</th>
                        <th width="140" class="text-align: right;">开始时间</th>
                        <th width="140" class="text-align: right;">结束时间</th>
                        <th width="150">操作</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr v-for="(item,index) in contract.contractServcList" class="row">
                        <td>
                            <span class="fl">{{ item.devcGroupFullName || '' }}</span>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.innerDevcBrandId'">
                                <span class="fl">{{ item.innerDevcBrandName || '' }}</span>
                            </el-form-item>
                        </td>
                        <td>
                            <span>{{ item.servcTypeName || '' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.goodsCatName || '' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.servcSpec || '' }}</span>
                        </td>
                        <td>
                            <span class="fl" v-if="item.devcPartsOnly != null">{{ item.devcPartsOnly ? '是' : '否' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.devcParts || '' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.title || '' }}</span>
                            <a class="swb-btn-link fr" v-if="operateContract !='chakan' && !disabled" @click="showMsuListDlg(item, index, false)">选择</a>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.toDoorFee'" :rules="{validator: moneyCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model="item.toDoorFee" @change="toDoorFeeChange(index, false)" v-if="checkActionPerm('view_item_price') || operateContract!='chakan'"
                                          :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                <el-input v-else disabled type="text" value="没有权限"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.price'" :rules="{validator: moneyCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model="item.price" @change="priceChange(index, false)" v-if="checkActionPerm('view_item_price') || operateContract!='chakan'"
                                          :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                <el-input v-else disabled type="text" value="没有权限"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.rspTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model.number="item.rspTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.arriveTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model.number="item.arriveTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.repairedTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model.number="item.repairedTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.wrntPeriod'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model.number="item.wrntPeriod" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.telCallTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model.number="item.telCallTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.timesLimitType'">
                                <el-select v-model="item.timesLimitType" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="timesLimitTypeChange(index, false)">
                                    <el-option v-for="timesLimitType in timesLimitTypeList" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" :key="timesLimitType.value" :label="timesLimitType.text"
                                               :value="timesLimitType.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <template v-if="item.timesLimitType == 0">
                                <el-form-item :prop="'contractServcList.' + index + '.quantity'" :rules="{validator: quantityCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.quantity" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="quantityChange(index, false)"></el-input>
                                </el-form-item>
                            </template>
                        </td>
                        <td>
                            <!-- 服务次数允许修订 -->
                            <el-form-item :prop="'contractServcList.' + index + '.quantityRevisible'">
                                <input type="checkbox" v-model="item.quantityRevisible" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"/>
                            </el-form-item>
                        </td>
                        <td>
                            <span v-if="checkActionPerm('view_item_price')">{{ item.amount }}</span>
                            <span v-else>没有权限</span>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.dateStart'" :rules="{validator: checkDateStart, trigger: 'change'}">
                                <el-date-picker style="width: 120px;" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="item.dateStart" type="date" placeholder="选择日期"></el-date-picker>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.dateEnd'" :rules="{validator: checkDateEnd, trigger: 'change'}">
                                <el-date-picker style="width: 120px;" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="item.dateEnd" type="date" placeholder="选择日期"></el-date-picker>
                            </el-form-item>
                        </td>
                        <td>
                            <div @click="removeContractServc(index, false);" class="swb-btn swb-btn-link" v-if="showSave && contract.fstPartyConfirmed == false && contract.srcId == null">
                                <span>移除</span>
                            </div>
                            <!--<div @click="setOrgPrice(index, false);" class="swb-btn swb-btn-link" v-if="contract.srcId == null && contract.id != null && contract.contractAppliedShopList != null && contract.contractAppliedShopList.length > 0">-->
                            <!--<span>特定门店价格</span>-->
                            <!--</div>-->
                            <!--<div @click="setOrgQuantity(index, false);" class="swb-btn swb-btn-link" v-if="contract.srcId == null && item.timesLimitType == 1 && contract.id != null && contract.contractAppliedShopList != null && contract.contractAppliedShopList.length > 0">-->
                            <!--<span>门店服务次数</span>-->
                            <!--</div>-->
                            <div @click="setOrgSpecInfo(index, item.servcTypeId, item.timesLimitType, item.quantityRevisible, false);" class="swb-btn swb-btn-link"
                                 v-if="contract.srcId == null && contract.id != null && contract.contractAppliedShopList != null && contract.contractAppliedShopList.length > 0">
                                <!-- 【保养，检验，巡检】+ 按门店设定次数： 可设定总价-->
                                <span>{{ item.timesLimitType != 1 ? '设置特定门店价格' : '设置门店次数和价格' }}</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot class="foot">
                    <tr class="row">
                        <td colspan="19" style="padding: 10px; border: 1px solid #dfe6ec; text-align: center;" v-if="contract.fstPartyId != null && contract.fstPartyId > 0 && (showBtn === true || !disabledBtn) && operateContract!='chakan'">
                            <div @click="addContractServc(false);" class="swb-btn swb-btn-link">
                                <i class="icon iconfont icon-jiahao mr5"></i>
                                <a href="#">添加</a>
                            </div>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </el-form>
        </div>

        <div class="content-caption dashed">
            <span>常规服务请求</span>
        </div>
        <div class="table-layout" style="overflow:auto">
            <el-form :model="contract" ref="contractServc2List">
                <table class="custom-tbl error-prompt">
                    <thead class="head">
                    <tr class="row">
                        <th width="150" class="text-align: left;">服务类型</th>
                        <th width="200" class="text-align: left;">常规服务需求</th>
                        <th width="200" class="text-align: left;">服务内容</th>
                        <th width="200" class="text-align: left;">服务项目</th>
                        <th width="140" class="text-align: right;">上门费(元)</th>
                        <th width="140" class="text-align: right;">服务费(元)</th>
                        <th width="140" class="text-align: right;">要求响应时长(分钟)</th>
                        <th width="140" class="text-align: right;">要求到达时长(分钟)</th>
                        <th width="140" class="text-align: right;">要求维修时长(分钟)</th>
                        <th width="120" class="text-align: right;">要求质保时长(天)</th>
                        <th width="140" class="text-align: right;">电话回询时限(分钟)</th>
                        <th width="200" class="text-align: right;">服务次数</th>
                        <th width="140" class="text-align: right;">服务次数允许修订</th>
                        <th width="140" class="text-align: right;">小计(元)</th>
                        <th width="140" class="text-align: right;">开始时间</th>
                        <th width="140" class="text-align: right;">结束时间</th>
                        <th width="150">操作</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr v-for="(item,index) in contract.contractServc2List" class="row">
                        <td>
                            <span>{{ item.servcTypeName || '' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.comnRequireTitle || '' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.servcSpec || '' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.title || '' }}</span>
                            <a class="swb-btn-link fr" v-if="operateContract !='chakan' && !disabled" @click="showMsuListDlg(item, index, true)">选择</a>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServc2List.' + index + '.toDoorFee'" :rules="{validator: moneyCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model="item.toDoorFee" @change="toDoorFeeChange(index, true)" v-if="checkActionPerm('view_item_price') || operateContract!='chakan'"
                                          :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                <el-input v-else disabled type="text" value="没有权限"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServc2List.' + index + '.price'" :rules="{validator: moneyCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model="item.price" @change="priceChange(index, true)" v-if="checkActionPerm('view_item_price') || operateContract!='chakan'"
                                          :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                                <el-input v-else disabled type="text" value="没有权限"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServc2List.' + index + '.rspTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model.number="item.rspTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServc2List.' + index + '.arriveTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model.number="item.arriveTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServc2List.' + index + '.repairedTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model.number="item.repairedTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServc2List.' + index + '.wrntPeriod'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model.number="item.wrntPeriod" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServc2List.' + index + '.telCallTimeMi'" :rules="{validator: timeMiCheck, trigger: 'blur'}">
                                <el-input type="number" :min="0" v-model.number="item.telCallTimeMi" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServcList.' + index + '.timesLimitType'">
                                <el-select v-model="item.timesLimitType" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" @change="timesLimitTypeChange(index, true)">
                                    <el-option v-for="timesLimitType in timesLimitTypeList" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" :key="timesLimitType.value" :label="timesLimitType.text"
                                               :value="timesLimitType.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <template v-if="item.timesLimitType == 0">
                                <el-form-item :prop="'contractServc2List.' + index + '.quantity'" :rules="{validator: quantityCheck, trigger: 'blur'}">
                                    <el-input type="number" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" :min="0" v-model.number="item.quantity" @change="quantityChange(index, true)"></el-input>
                                </el-form-item>
                            </template>
                        </td>
                        <td>
                            <!-- 服务次数允许修订 -->
                            <el-form-item :prop="'contractServcList.' + index + '.quantityRevisible'">
                                <input type="checkbox" v-model="item.quantityRevisible" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'"/>
                            </el-form-item>
                        </td>
                        <td>
                            <span v-if="checkActionPerm('view_item_price')">{{ item.amount }}</span>
                            <span v-else>没有权限</span>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServc2List.' + index + '.dateStart'" :rules="{validator: checkDateStart, trigger: 'change'}">
                                <el-date-picker style="width: 120px;" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="item.dateStart" type="date" placeholder="选择日期"></el-date-picker>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'contractServc2List.' + index + '.dateEnd'" :rules="{validator: checkDateEnd, trigger: 'change'}">
                                <el-date-picker style="width: 120px;" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="item.dateEnd" type="date" placeholder="选择日期"></el-date-picker>
                            </el-form-item>
                        </td>
                        <td>
                            <div @click="removeContractServc(index, true);" class="swb-btn swb-btn-link" v-if="showSave && contract.fstPartyConfirmed == false && contract.srcId == null">
                                <span>移除</span>
                            </div>
                            <!--<div @click="setOrgPrice(index, true);" class="swb-btn swb-btn-link" v-if="contract.srcId == null && contract.id != null && contract.contractAppliedShopList != null && contract.contractAppliedShopList.length > 0">-->
                            <!--<span>特定门店价格</span>-->
                            <!--</div>-->
                            <!--<div @click="setOrgQuantity(index, true);" class="swb-btn swb-btn-link" v-if="contract.srcId == null && item.timesLimitType == 1 && contract.id != null && contract.contractAppliedShopList != null && contract.contractAppliedShopList.length > 0">-->
                            <!--<span>门店服务次数</span>-->
                            <!--</div>-->
                            <div @click="setOrgSpecInfo(index, item.servcTypeId, item.timesLimitType, item.quantityRevisible, true);" class="swb-btn swb-btn-link"
                                 v-if="contract.srcId == null && contract.id != null && contract.contractAppliedShopList != null && contract.contractAppliedShopList.length > 0">
                                <!-- 【保养，检验，巡检】+ 按门店设定次数： 可设定总价-->
                                <span>{{ item.timesLimitType != 1 ? '设置特定门店价格' : '设置门店次数和价格' }}</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot class="foot">
                    <tr class="row">
                        <td colspan="16" style="padding: 10px; border: 1px solid #dfe6ec; text-align: center;" v-if="contract.fstPartyId != null && contract.fstPartyId > 0 && (showBtn === true || !disabledBtn) && operateContract!='chakan'">
                            <div @click="addContractServc(true);" class="swb-btn swb-btn-link">
                                <i class="icon iconfont icon-jiahao mr5"></i>
                                <a href="#">添加</a>
                            </div>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </el-form>
        </div>

        <div class="simple-form" v-if="contractType != servcDlgt.value && contract.kindId != null && contract.kindId == 0">
            <div class="form-group">
                <div class="form-label">
                    <label>预计合同总额：</label>
                </div>
                <div class="form-value width-2x">
                    <input v-if="checkActionPerm('view_total_price') || operateContract!='chakan'" :disabled="((showBtn ===  false || disabledBtn) && operateContract!='change') && showAmtAndCot"
                           style="border:1px solid #DDDDDD; width: 100px; height: 30px;" v-model.number="contract.estmtAmount"/>
                    <input v-else disabled style="border:1px solid #DDDDDD; width: 65px; height: 30px;" value="没有权限"/>元
                    <span v-if="checkActionPerm('view_total_price')">(含服务包死价{{
                            (contract.totalServcAmount == null || contract.totalServcAmount == '') ? 0 : ((contract.totalServcAmount).toFixed(0)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
                        }}元)</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>&nbsp;</label>
                </div>
                <div class="form-value width-2x">
                    <el-checkbox :disabled="((showBtn ===  false || disabledBtn) && operateContract!='change') && showAmtAndCot" @change="servcAmountFixedChange" v-model="contract.servcAmountFixed">
                        <span>服务是否包死价</span>
                    </el-checkbox>
                </div>
            </div>
            <div class="form-group" v-if="contract.servcAmountFixed">
                <div class="form-label">
                    <label>服务包死价总额：</label>
                </div>
                <div class="form-value width-2x">
                    <el-input v-if="checkActionPerm('view_total_price')" :disabled="((showBtn ===  false || disabledBtn) && operateContract!='change') && showAmtAndCot" style="border:1px solid #DDDDDD; width: 65px; height: 30px;"
                              @change="servcAmountChange" v-model.number="contract.totalServcAmount"/>
                    元
                    <input v-if="!checkActionPerm('view_total_price')" :disabled="true" style="border:1px solid #DDDDDD; width: 65px; height: 30px;" value="没有权限"/>
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>纳入结算单费用项</span>
        </div>
        <div>
            <el-checkbox-group v-model="contract.settleInvolvedFeeTypeIds" @change="changeWorkFeeType" :disabled="operateContract=='chakan'">
                <el-checkbox class="mt10" v-for="workFeeType in workFeeTypeList" :label="workFeeType.value">{{ workFeeType.text }}</el-checkbox>
            </el-checkbox-group>
        </div>
        <div class="content-caption dashed">
            <span>配件信息</span>
        </div>
        <div class="simple-form flex col-3 label">
            <div class="form-group center">
                <div class="form-label">
                    <label>配件审核规则</label>
                </div>
                <div class="form-value"></div>
            </div>
        </div>
        <div class="simple-form flex col-3 label">
            <div class="form-group center">
                <div class="form-label">
                    <label>服务商配件</label>
                </div>
                <div class="form-value">
                    <el-select v-model="contract.useAccAuditRule" :disabled="operateContract=='chakan'">
                        <el-option v-for="accAuditRule in accAuditRuleList" :label="accAuditRule.text" :value="accAuditRule.value"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="simple-form flex col-3 label" v-if="contract.useAccAuditRule">
            <div class="form-group center">
                <div class="form-label">
                    <label></label>
                </div>
                <div class="form-value">
                    <div>
                        <el-checkbox class="mt10" v-model="contract.sglAccAuditEnabled" :disabled="operateContract=='chakan'"></el-checkbox>
                        单个配件大于

                        <el-input-number v-model="contract.sglAccAmntLimit" :controls="false" :min="0" :disabled="operateContract=='chakan'"></el-input-number>
                        元需要审批

                    </div>
                    <div>
                        <el-checkbox class="mt10" v-model="contract.sumAccAuditEnabled" :disabled="operateContract=='chakan'"></el-checkbox>
                        工单配件总金额大于

                        <el-input-number v-model="contract.sumAccAmntLimit" :controls="false" :min="0" :disabled="operateContract=='chakan'"></el-input-number>
                        元需要审批

                    </div>
                </div>
            </div>
        </div>

        <template v-if="contract.fstPartyId != null">
            <el-form :model="contract" :rules="contractRules" ref="contractInvoice" class="demo-ruleForm">
                <div class="simple-form flex col-2">
                    <div class="content-caption dashed">
                        <span>发票信息</span>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">发票类型</label>
                        </div>
                        <div class="form-value width-2x mt5">
                            <el-form-item prop="invoiceType">
                                <div v-if="(disabled || operateContract=='chakan') && operateContract!='change'">
                                    <ul class="enum-list">
                                        <li class="enum-item" v-bind:class="{checked : (merchantInvoiceType.value == contract.invoiceType)}" v-for="merchantInvoiceType in merchantInvoiceTypeList">
                                            {{ merchantInvoiceType.name }}<i></i></li>
                                        <li class="enum-item" v-bind:class="{checked : (contract.oldInvoiceType == contract.invoiceType)}"
                                            v-if="(!contract.hasInvoiceType || (merchantInvoiceTypeList || []).length <= 0) && contract.oldInvoiceType > 0">
                                            {{ invoiceTypeMap[contract.oldInvoiceType] }}<i></i>
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>
                                    <ul class="enum-list">
                                        <li class="enum-item" v-bind:class="{checked : (merchantInvoiceType.value == contract.invoiceType)}" v-for="merchantInvoiceType in merchantInvoiceTypeList"
                                            @click="checkInvoiceType(merchantInvoiceType.value)">
                                            {{ merchantInvoiceType.name }}<i></i></li>
                                        <li class="enum-item" v-bind:class="{checked : (contract.oldInvoiceType == contract.invoiceType)}" @click="checkInvoiceType(contract.oldInvoiceType)"
                                            v-if="(!contract.hasInvoiceType || (merchantInvoiceTypeList || []).length <= 0) && contract.oldInvoiceType > 0">
                                            {{ invoiceTypeMap[contract.oldInvoiceType] }}<i></i>
                                        </li>
                                    </ul>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>发票抬头</label>
                        </div>
                        <div class="form-value width-2x">
                            <el-form-item prop="invoiceTitle">
                                <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.invoiceTitle"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>发票内容标签</label>
                        </div>
                        <div class="form-value width-2x mt5">
                            <el-form-item prop="invoiceContentTag">
                                <div v-if="(disabled || operateContract=='chakan') && operateContract!='change'">
                                    <ul class="enum-list">
                                        <li class="enum-item" v-bind:class="{checked : invoiceContentTag.name == contract.invoiceContentTag}" v-for="invoiceContentTag in invoiceContentTagList">
                                            {{ invoiceContentTag.name }}<i></i></li>
                                    </ul>
                                </div>
                                <div v-else>
                                    <ul class="enum-list">
                                        <li class="enum-item" v-bind:class="{checked : invoiceContentTag.name == contract.invoiceContentTag}" v-for="invoiceContentTag in invoiceContentTagList"
                                            @click="checkinvoiceContentTag(invoiceContentTag.name)">
                                            {{ invoiceContentTag.name }}<i></i></li>
                                    </ul>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">纳税人识别号</label>
                        </div>
                        <div class="form-value width-2x">
                            <el-form-item prop="taxPayerNo">
                                <el-input :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" v-model="contract.taxPayerNo"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </el-form>
        </template>

        <div class="content-caption dashed">
            <span>付款信息</span>
        </div>
        <div class="simple-form flex col-3 label">
            <div class="form-group center">
                <div class="form-label">
                    <label>收款银行卡号</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" disabled type="text" v-model="contract.sndPartyCardNo"></el-input>
                    <div v-if="operateContract !='chakan'" class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectBackAcct()"></div>
                    <div v-if="operateContract !='chakan' && (contract.sndPartyCardNo != null ||  contract.sndPartyCardNo != '')" class="form-tips icon iconfont icon-fanhui relation-icon" title="移除" @click="clearBackAcct()"></div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>银行名称</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" disabled type="text" v-model="contract.sndPartyBankName"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>账号名称</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" disabled type="text" v-model="contract.sndPartyAcctName"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>银行账号</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" disabled type="text" v-model="contract.sndPartyAcctNo"></el-input>
                </div>
            </div>
        </div>


        <template v-if="contractType != servcDlgt.value && !contract.settleCrossOrderAllowed">
            <template v-if="contract.phaseFlag">
                <div class="content-caption dashed">
                    <span>履约阶段</span>
                </div>
                <swb-contract-track-phase ref="swb_contract_track_phase" :contractId="contract.id" :offline="contract.offline" :estmtAmount="contract.estmtAmount" :estmtGoodsCount="contract.estmtGoodsCount" :contractType="contractType"
                                          :operate="operateContract"></swb-contract-track-phase>
                <div class="simple-form">
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">是否按阶段履约</label>
                        </div>
                        <div class="form-value width-3x">
                            <el-radio-group :disabled="contract.id != null && operateContract != 'change'" v-model="contract.trackByPhase">
                                <el-radio :label="false"><span>否</span></el-radio>
                                <el-radio :label="true"><span>是</span></el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
            </template>
        </template>

        <div class="content-caption dashed">
            <span>附件信息</span>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>&nbsp;&nbsp;</label>
            </div>
            <div class="form-value" v-if="showUpload || (contract.contractFileList !=null && contract.contractFileList.length > 0)">
                <swb-save-file :showDelete="showSave" :files="contract.contractFileList" ref="swb_contract_file"></swb-save-file>
            </div>
        </div>
        <div class="content-caption dashed" v-if="contractType != servcDlgt.value && contract.termsFlag">
            <span>条款信息</span>
        </div>

        <swb-create-trade-rule v-if="contractType != servcDlgt.value && contract.termsFlag" :comparedTradeRuleList="comparedTradeRuleList" :type="tradeType" :operate="tradeOperate" :isOwner=false :forBid="forBid" :forContract="forContract"
                               :forGoods="forGoods" :forServc="forServc" :forPriceInqry="forPriceInqry" ref="swb_create_trade_rule"></swb-create-trade-rule>

        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary" @click="prevContract">返回</button>

            <button v-if="showSave && operateContract == 'change'" class="swb-btn swb-btn-small" @click="registerContract">变更</button>
            <button v-if="!contract.closed && operateContract != 'change' && operateContract != 'chakan'" class="swb-btn swb-btn-small" @click="registerContract">
                <span>保存</span>
            </button>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import appConf from '../../app.conf';
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {checkUserActionPerm} from '../index'
    import {CtrlParamCodes} from '../../app.const'
    import {
        openContractGoodsAreaPriceDlg,
        openContractServcOrgQuantitySetDlg,
        openContractServcOrgSpecListDlg,
        openContractServcOrgPriceSetDlg
    } from './dialog'
    import {showRouteLayer} from '../ctrl/RouteLayer'

    import merchtFinacApi from '../../api/merchtFinac'
    import userApi from '../../api/user'
    import contractApi from '../../api/contract'
    import tendBidApi from '../../api/tendBid'
    import priceApi from '../../api/price'
    import merchtComnApi from '../../api/merchtComn'
    import merchtQualiApi from '../../api/merchtQuali'
    import finacApi from '../../api/finac'
    import fiscalBizApi from '../../api/fiscalBiz'
    import servicerApi from '../../api/servicer'

    import SwbFileUpload from '../ctrl/FileUpload';

    Vue.regist(SwbFileUpload);

    import SwbVendorListForSelect from '../vendor/VendorListForSelect';

    Vue.regist(SwbVendorListForSelect);

    import SwbRetailerListForSelect from '../retailer/RetailerListForSelect';

    Vue.regist(SwbRetailerListForSelect);

    import SwbMsuListForSelect from '../servc/MsuListForSelect';

    Vue.regist(SwbMsuListForSelect);

    import SwbSaveFile from './SaveFile';

    Vue.regist(SwbSaveFile);

    import SwbCreateTradeRule from '../tradeRule/CreateTradeRule';

    Vue.regist(SwbCreateTradeRule);

    import SwbBidDocForSelect from '../callbid/BidDocForSelect';

    Vue.regist(SwbBidDocForSelect);

    import SwbContractTrackPhase from './ContractTrackPhase';

    Vue.regist(SwbContractTrackPhase);

    import SwbContractDataMonitoring from './ContractDataMonitoring';

    Vue.regist(SwbContractDataMonitoring);

    import SwbContractRecordList from './ContractRecordList';

    Vue.regist(SwbContractRecordList);

    import SwbPriceReplyForSelect from '../priceReply/PriceReplyForSelect';

    Vue.regist(SwbPriceReplyForSelect);

    import SwbServcPurchContractList from './ServcPurchContractList';

    Routes.add(SwbServcPurchContractList);

    import SwbServcDlgtContractList from './ServcDlgtContractList';

    Routes.add(SwbServcDlgtContractList);

    import IntegPurchContractList from './IntegPurchContractList';

    Routes.add(IntegPurchContractList);

    import SwbRcvVoucherList from '../payment/RcvVoucherList';

    Routes.add(SwbRcvVoucherList);
    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';

    Routes.add(SwbTradeVoucherList);

    import {openSkuListSelectDlg} from '../goods/selectDlg';
    import {openVendorSelectComnDlg} from '../vendor/selectDlg';
    import {openRetailerSelectComnDlg} from '../retailer/selectDlg';
    import {selectMerchantRealComDlg} from '../realCom/dialog'
    import {selectRealComBankAcctDialog} from '../merchtFinac/selectDlg'

    export default {
        name: 'swb-register-comn-seller-contract',
        desc: '甲方登记合同',
        props: ['contractId', 'operate', 'contractType', 'srcMerchant', 'sndMerchant'],
        data: function () {
            let self = this;
            let checkTitle = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    if (value.length > 60) {
                        callback(new Error('合同名称不能超过60个字符!'));
                    } else {
                        callback();
                    }
                }
            };
            let checkFstPartyId = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkAccordHtBh = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkDateStart = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkDateEnd = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkSignDate = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkSrcWinId = function (rule, value, callback) {
                let srcFlag = self.contract.srcFlag;
                if (srcFlag != 0) {
                    if (Utils.isNoB(value)) {
                        callback(new Error('不能为空!'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            let checkTaxRate = function (rule, value, callback) {
                self.validateTaxRate(rule, value, callback);
            };
            return {
                contract: {
                    id: null,
                    kindId: 0, // 0,标准合同，1,框架合同
                    phaseFlag: true,// 是否有履约阶段
                    termsFlag: true,// 是否有条款项
                    originalNo: null,
                    typeId: null,
                    typeName: null,
                    srcFlag: 0,
                    offline: false,
                    fstPartyId: null,
                    fstPartyName: null,
                    signDate: null,
                    sndPartyId: null,
                    sndPartyName: null,
                    contractServcList: [],
                    contractDigest: {},
                    contractFileList: [],
                    dateStart: null,
                    dateEnd: null,
                    contractTermList: [],
                    srcId: null,
                    invoiceType: null,
                    invoiceContentTag: null,
                    contractGoodsList: [],
                    estmtAmount: null,
                    estmtGoodsCount: null,
                    trackByPhase: true,
                    contractTrackPhaseList: [],
                    fstPartyConfirmed: false,
                    sndPartyConfirmed: false,
                    goodsFlag: true,
                    servcFlag: false,

                    checkAuditState: 0,
                    checkApplyState: 0,
                    fulfillAuditState: 0,
                    fulfillApplyState: 0,
                    servcAmountFixed: false,
                    totalServcAmount: null,

                    srcWinId: null,
                    sndPartyFlag: null,
                    proxied: true,
                    servcType: 0,
                    settleCrossOrderAllowed: false,

                    settleAutoFlag: false,
                    settlePeriodDay: 1,
                    settleInvolvedFeeTypeIds: [1],  // 默认选择服务费
                    //
                    useAccAuditRule: false,
                    sglAccAuditEnabled: false,
                    sglAccAmntLimit: 0.00,
                    sumAccAuditEnabled: false,
                    sumAccAmntLimit: 0.00,
                },
                accAuditRuleList: [{text: '不需审批', value: false}, {text: '需要审批', value: true}],
                showBtn: false,
                showSave: true,
                comparedTradeRuleList: [],
                tradeType: null,
                tradeOperate: null,
                disabled: false,
                showUpload: false,
                disabledBtn: false,
                showAmtAndCot: true,
                merchantInvoiceTypeList: [],
                invoiceContentTagList: [],
                invoiceFlag: false,
                prevChangeContract: {},
                tradeVoucher: {},
                timesLimitTypeList: getEnumList('timesLimitType') || [],
                contractRules: {
                    title: [{
                        validator: checkTitle,
                        trigger: 'blur'
                    }],
                    fstPartyId: [{
                        validator: checkFstPartyId,
                        trigger: 'change'
                    }],
                    accordHtBh: [{
                        validator: checkAccordHtBh,
                        trigger: 'change'
                    }],
                    dateStart: [{
                        validator: checkDateStart,
                        trigger: 'change'
                    }],
                    dateEnd: [{
                        validator: checkDateEnd,
                        trigger: 'change'
                    }],
                    signDate: [{
                        validator: checkSignDate,
                        trigger: 'change'
                    }],
                    srcWinId: [{
                        validator: checkSrcWinId,
                        trigger: 'change'
                    }],
                    taxRate: [{
                        validator: checkTaxRate,
                        trigger: 'blur'
                    }]
                },

                servcPurch: getEnumInfoWith("contractType", 'name', 'ServcPurch'),
                integPurch: getEnumInfoWith("contractType", 'name', 'IntegPurch'),
                servcDlgt: getEnumInfoWith("contractType", 'name', 'ServcDlgt'),
                bizSrcFlagList: getEnumList("bizSrcFlag"),
                forBid: null,
                forContract: true,
                forGoods: null,
                forServc: null,
                forPriceInqry: null,

                goodsAmount: 0,
                servcAmount: 0,

                flag: false,
                operateContract: null,
                //
                path: null,
                isLegacyContract: false,
                servcType: 0,
                fiscalTaxMarkList: [],
                normalFlag: false, // 零售商是否开启财务在账
                invoiceTypeMap: getEnumMap('invoiceType', 'value2text'),
                workFeeTypeList: [],
                scopeEntity: {}
            }
        },
        created: function () {
            this.operateContract = this.operate;
            let workFeeTypeList = getEnumList("servcFeeType");
            let newWorkFeeTypeList = [];
            for (let i = 0; i < workFeeTypeList.length; i++) {
                let workFeeType = workFeeTypeList[i];
                if (workFeeType.value != 3 && workFeeType.value != 9) {
                    newWorkFeeTypeList.push(workFeeType);
                }
            }
            this.workFeeTypeList = Utils.merge([], newWorkFeeTypeList);
            //
            if (this.contractType == this.integPurch.value) {
                this.forServc = true;
                this.forGoods = true;
            } else {
                this.forServc = true;
            }
            let contractId = this.contractId;
            if (!Utils.isNoB(contractId)) {
                this.getContractById(contractId);
                let operation = this.operateContract;
                this.tradeOperate = operation;
                if (operation == 'chakan') {
                    this.showSave = false;
                    this.showBtn = false;
                } else {
                    this.showSave = true;
                    this.showBtn = true;
                }
            } else {
                this.getCurrentUserInfo();
                this.getContractTypeList();
                this.showUpload = true;
            }

            // 设置拦截的路径
            let contractType = this.contractType;
            if (contractType == 2) {
                // 服务采购合同
                this.path = SwbServcPurchContractList.path;
            } else if (contractType == 3) {
                // 集成采购合同
                this.path = IntegPurchContractList.path;
            }

            this.checkLegacyContract();
        },
        methods: {
            // 检查是否是老合同
            checkLegacyContract: function () {
                let self = this;
                contractApi.checkLegacyContract(function (result) {
                    if (result.type == 'info') {
                        self.isLegacyContract = result.data;
                    } else {
                        console.warn(result.message);
                    }
                });
            },
            checkTime: function () {
                let self = this;
                let contract = self.contract;
                if (!Utils.isNoB(contract.dateStart) && !Utils.isNoB(contract.dateEnd)) {
                    // 判断时间大小
                    let dateStart = contract.dateStart.format("yyyy-MM-dd");
                    let dateEnd = contract.dateEnd.format("yyyy-MM-dd");
                    if (dateStart >= dateEnd) {
                        MsgBox.warning("请输入有效的合同开始结束时间");
                        return false;
                    }
                }
            },
            checkActionPerm: function (action) {
                return checkUserActionPerm(this.path, action, null);
            },
            editable: function () {
                this.operateContract = "edit";
                // this.contract.dirty = true;
                this.tradeOperate = null;
                if (this.contract.srcWinId != null || this.contract.srcWinId != null) {
                    this.disabledBtn = true;
                } else {
                    this.disabledBtn = false;
                }
                this.showSave = true;
                this.showBtn = true;
            },
            inputWrntPeriod: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请输入质保期'));
                } else {
                    if (!Utils.isNumber(value) || value < 0) {
                        callback(new Error('请输入整数'));
                    } else {
                        callback();
                    }
                }
            },
            checkDateStart: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            checkDateEnd: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            changeSignDate: function () {
                let self = this;
                let signDate = self.contract.signDate;
                let dueDate = new Date(signDate);
                let contractTrackPhaseList = self.contract.contractTrackPhaseList;
                if (contractTrackPhaseList.length > 0) {
                    for (let i = 0; i < contractTrackPhaseList.length; i++) {
                        let absDate = contractTrackPhaseList[i].absDate;
                        if (!absDate) {
                            contractTrackPhaseList[i].dueDate = dueDate.addDays(contractTrackPhaseList[i].incrDays).format('yyyy-MM-dd');
                        }
                    }
                }
                self.contract.contractTrackPhaseList = Utils.merge([], contractTrackPhaseList);
            },
            // 含税价
            goodsAmountOrQuantityChange: function (item, index, changeFlag) {
                let self = this;
                let goodsAmount = 0;
                let estmtGoodsCount = 0;
                let contractGoodsList = self.contract.contractGoodsList;
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let quantity = contractGoodsList[i].quantity;
                    let price = contractGoodsList[i].price;
                    if (i == index && changeFlag == 'quantity') {
                        if (Utils.isNoB(quantity)) {
                            MsgBox.warning("请输入商品数量！");
                        } else if (!Utils.isInt(quantity) || quantity < 0) {
                            MsgBox.warning("只能输入大于0的整数！");
                            quantity = null;
                        } else {
                            contractGoodsList[i].amount = ((Utils.isNoB(price) ? 0 : parseFloat(price)) * parseInt(quantity)).toFixed(2);
                        }
                    }
                    if (i == index && changeFlag == 'price') {
                        if (Utils.isNoB(price)) {
                            MsgBox.warning("请输入金额！");
                            price = null;
                        } else if (!Utils.isMoneyStr(price)) {
                            MsgBox.warning("请输入正确的金额！");
                            price = null;
                        }
                        // 未税价格
                        if (!Utils.isNoB(price)) {
                            let taxRate = contractGoodsList[i].taxRate || 0;
                            contractGoodsList[i].ntxPrice = (parseFloat(price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                            contractGoodsList[i].amount = ((Utils.isNoB(quantity) ? 0 : parseInt(quantity)) * parseFloat(price)).toFixed(2);
                        } else {
                            contractGoodsList[i].ntxPrice = null;
                        }
                    }
                    if (!Utils.isNoB(quantity)) {
                        estmtGoodsCount += quantity;
                    }
                    if (!Utils.isNoB(price) && !Utils.isNoB(quantity)) {
                        let amount = contractGoodsList[i].amount;
                        if (!Utils.isNoB(amount)) {
                            goodsAmount += parseFloat(amount);
                        }
                    }
                    contractGoodsList[i].quantity = quantity;
                    contractGoodsList[i].price = Utils.isNoB(price) ? null : parseFloat(price).toFixed(2);
                }
                //
                self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                self.goodsAmount = goodsAmount.toFixed(2);
                self.contract.estmtAmount = (parseFloat(self.goodsAmount) + parseFloat(self.servcAmount || 0)).toFixed(2);
                self.contract.estmtGoodsCount = estmtGoodsCount;
            },
            // 税率校验
            validateTaxRate: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('请输入税率！'));
                } else {
                    if (!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的税率！'));
                    } else {
                        let taxRate = parseFloat(value);
                        if (taxRate > 100) {
                            callback(new Error('税率不能超过100！'));
                        } else {
                            callback();
                        }
                    }
                }
            },
            // 税率变化事件
            taxRateChange: function (taxRate) {
                if (!Utils.isNoB(taxRate)) {
                    if (!Utils.isMoneyStr(taxRate)) {
                        taxRate = null;
                    } else {
                        let taxRateF = parseFloat(taxRate);
                        if (taxRateF > 100) {
                            taxRate = null;
                        } else {
                            taxRate = taxRateF.toFixed(2);
                        }
                    }
                }
                //
                let contract = this.contract || {};
                contract.taxRate = taxRate;
                let contractGoodsList = contract.contractGoodsList || [];
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let item = contractGoodsList[i];
                    //
                    item.taxRate = taxRate;
                    if (Utils.isNoB(taxRate) || Utils.isNoB(item.price)) {
                        item.ntxPrice = item.price;
                    } else {
                        item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                    }
                }
                contract.contractGoodsList = Utils.merge([], contractGoodsList);
                this.contract = Utils.merge({}, contract);
            },
            servcAmountOrQuantityChange() {
                let self = this;
                let servcAmount = 0;
                let contract = self.contract || {};
                // 常规服务请求
                let contractServc2List = contract.contractServc2List || [];
                for (let i = 0; i < contractServc2List.length; i++) {
                    let amount = contractServc2List[i].amount || 0;
                    servcAmount += parseFloat(amount);
                }
                // 设备维保服务
                let contractServcList = contract.contractServcList || [];
                for (let i = 0; i < contractServcList.length; i++) {
                    let amount = contractServcList[i].amount || 0;
                    servcAmount += parseFloat(amount);
                }
                //
                self.servcAmount = servcAmount.toFixed(2);
                self.contract.estmtAmount = (parseFloat(self.servcAmount || 0) + parseFloat(self.goodsAmount || 0)).toFixed(2);
            },
            setGoodsAndServcAmount() {
                let self = this;
                //
                let goodsAmount = 0;
                let contractGoodsList = self.contract.contractGoodsList;
                for (let i = 0; i < contractGoodsList.length; i++) {
                    let quantity = contractGoodsList[i].quantity;
                    let price = contractGoodsList[i].price;
                    if (!Utils.isNoB(quantity)) {
                        if (!Utils.isInt(quantity) || quantity < 0) {
                            return;
                        }
                    }
                    if (!Utils.isNoB(price) && !Utils.isNoB(quantity)) {
                        goodsAmount += quantity * price;
                    }
                }
                self.goodsAmount = goodsAmount.toFixed(2);
                //
                let servcAmount = 0;
                // 设备维保服务
                let contractServcList = self.contract.contractServcList || [];
                if (contractServcList.length > 0) {
                    for (let i = 0; i < contractServcList.length; i++) {
                        let contractServc = contractServcList[i];
                        let quantity = contractServc.quantity || 0;
                        let price = contractServc.price || 0;
                        let toDoorFee = contractServc.toDoorFee || 0;
                        let amount = contractServc.amount || 0;
                        //
                        servcAmount += parseInt(quantity) * parseFloat(amount);
                        contractServc.toDoorFee = parseFloat(toDoorFee).toFixed(2);
                        contractServc.price = parseFloat(price).toFixed(2);
                        contractServc.amount = parseFloat(amount).toFixed(2);
                    }
                    self.contract.contractServcList = Utils.merge([], contractServcList);
                }
                // 常规服务请求
                let contractServc2List = self.contract.contractServc2List || [];
                if (contractServc2List.length > 0) {
                    for (let i = 0; i < contractServc2List.length; i++) {
                        let contractServc = contractServc2List[i];
                        let quantity = contractServc.quantity || 0;
                        let price = contractServc.price || 0;
                        let toDoorFee = contractServc.toDoorFee || 0;
                        let amount = contractServc.amount || 0;
                        //
                        servcAmount += parseInt(quantity) * parseFloat(amount);
                        contractServc.toDoorFee = parseFloat(toDoorFee).toFixed(2);
                        contractServc.price = parseFloat(price).toFixed(2);
                        contractServc.amount = parseFloat(amount).toFixed(2);
                    }
                    self.contract.contractServc2List = Utils.merge([], contractServc2List);
                }
                self.servcAmount = parseFloat(servcAmount || 0).toFixed(2);
            },
            servcAmountFixedChange: function (val) {
                let self = this;
                let servcAmountFixed = self.contract.servcAmountFixed;
                //
                let servcAmount = 0;
                if (servcAmountFixed) {
                    if (self.contract.totalServcAmount != null && self.contract.totalServcAmount != "") {
                        servcAmount = self.contract.totalServcAmount;
                    }
                } else {
                    self.contract.totalServcAmount = null;
                    // 设备维保服务
                    let contractServcList = self.contract.contractServcList || [];
                    if (contractServcList.length > 0) {
                        for (let i = 0; i < contractServcList.length; i++) {
                            let contractServc = contractServcList[i];
                            let amount = contractServc.amount || 0;
                            //
                            servcAmount += parseFloat(amount);
                        }
                    }
                    // 常规服务请求
                    let contractServc2List = self.contract.contractServc2List || [];
                    if (contractServc2List.length > 0) {
                        for (let i = 0; i < contractServc2List.length; i++) {
                            let contractServc = contractServc2List[i];
                            let amount = contractServc.amount || 0;
                            //
                            servcAmount += parseFloat(amount);
                        }
                    }
                }
                self.servcAmount = parseFloat(servcAmount || 0).toFixed(2);
                self.contract.estmtAmount = (parseFloat(self.servcAmount) + parseFloat(self.goodsAmount || 0)).toFixed(2);
            },
            servcAmountChange: function () {
                let self = this;
                let estmtAmount = 0;
                if (self.contract.totalServcAmount != null && self.contract.totalServcAmount != "") {
                    estmtAmount = self.contract.totalServcAmount;
                } else {
                    self.contract.totalServcAmount = null;
                }
                self.servcAmount = parseFloat(estmtAmount || 0).toFixed(2);
                self.contract.estmtAmount = (parseFloat(self.goodsAmount || 0) + parseFloat(self.servcAmount || 0)).toFixed(2);
            },
            getInvoiceTypeList: function (callback) {
                let self = this;
                let postData = {};
                postData.realComId = self.contract.sndPartyRealComId;
                postData.merchantType = self.servcPurch.sndPartyType;
                merchtFinacApi.getMerchantInvoiceTypeListAvailable(postData, function (result) {
                    if (result.type == 'info') {
                        let data = result.data;
                        if (data != null && data.length > 0) {
                            let merchantInvoiceTypeList = data;
                            self.merchantInvoiceTypeList = Utils.merge([], merchantInvoiceTypeList);
                            let contract = self.contract || {};
                            let invoiceType = contract.invoiceType;
                            let hasInvoiceType = false;
                            for (let i = 0; i < merchantInvoiceTypeList.length; i++) {
                                let merchantInvoiceType = merchantInvoiceTypeList[i];
                                if (merchantInvoiceType.value == invoiceType) {
                                    hasInvoiceType = true;
                                }
                            }
                            contract.oldInvoiceType = invoiceType;
                            contract.hasInvoiceType = hasInvoiceType;
                            self.contract = Utils.merge({}, contract);
                        } else {
                            self.invoiceFlag = false;
                            self.merchantInvoiceTypeList = [];
                            self.contract = Utils.merge({}, self.contract);
                        }
                        if (typeof callback == 'function') {
                            callback();
                        }
                    }
                });
            },
            getInvoiceContentTagList: function () {
                let self = this;
                let postData = {};
                postData.merchantId = self.contract.sndPartyId;
                postData.merchantType = self.servcPurch.sndPartyType;
                merchtFinacApi.getMerchantInvoiceCtntTagList(postData, function (result) {
                    if (result.type == 'info') {
                        if (result.data != null && result.data.length > 0) {
                            self.invoiceContentTagList = result.data;
                        } else {
                            self.contract.invoiceContentTag = null;
                            self.invoiceFlag = false;
                            self.invoiceContentTagList = [];
                            self.contract = Utils.merge({}, self.contract);
                        }
                    }
                });
            },
            checkInvoiceType: function (value) {
                let self = this;
                self.contract.invoiceType = value;
                self.getMerchantInvoiceSubjectByOnly();
            },
            checkinvoiceContentTag: function (name) {
                let self = this;
                self.contract.invoiceContentTag = name;
            },
            getMerchantInvoiceSubjectByOnly: function () {
                let self = this;
                let postData = {};
                postData.merchantRealId = self.contract.fstPartyRealId;
                postData.realComId = self.contract.fstPartyRealComId;
                if (self.contractType == self.servcDlgt.value) {
                    postData.merchantType = self.servcDlgt.fstPartyType;
                } else {
                    postData.merchantType = self.servcPurch.fstPartyType;
                }
                postData.invoiceType = self.contract.invoiceType;
                merchtFinacApi.getMerchantInvoiceSubjectList(postData, function (result) {
                    if (result.type == 'info') {
                        let invoiceSubjectList = Utils.merge([], result.data);
                        if (invoiceSubjectList.length > 0) {
                            let invoiceSubjectInfo = null;
                            for (let i = 0; i < invoiceSubjectList.length; i++) {
                                if (Utils.isTrue(invoiceSubjectList[i].defaulted)) {
                                    invoiceSubjectInfo = invoiceSubjectList[i];
                                    break;
                                }
                            }
                            self.contract.invoiceTitle = invoiceSubjectInfo.invoiceTitle;
                            self.contract.taxPayerNo = invoiceSubjectInfo.taxPayerNo;
                            self.invoiceFlag = true;
                            self.contract = Utils.merge({}, self.contract);
                        } else {
                            self.contract.invoiceTitle = null;
                            self.contract.taxPayerNo = null;
                            self.invoiceFlag = false;
                            self.contract = Utils.merge({}, self.contract);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getCurrentUserInfo: function () {
                let self = this;
                let postData = {};
                userApi.getUserInfoByContext(postData, function (result) {
                    if (result.type == "info") {
                        self.contract.sndPartyName = result.data.scopeEntity.name;
                        self.contract.sndPartyId = result.data.scopeEntity.id;
                        self.scopeEntity = result.data.scopeEntity;
                        self.contract.sndPartyType = self.servcPurch.sndPartyType;
                        //
                        self.getComInfo(result.data.scopeEntity.comId);
                    }
                });
            },
            getComInfo: function (comId) {
                let self = this;
                let postData = {};
                postData.comId = comId;
                servicerApi.getServicerCom(postData, function (result) {
                    if (result.type === 'info') {
                        let comInfo = result.data;
                        self.contract.sndPartyComId = comInfo.id;
                        self.contract.sndPartyRealComId = comInfo.realComId;
                        self.contract.sndPartyRealComName = comInfo.realComName;
                        // 获取默认收款银行卡号
                        self.getDefaultBankAcctInfo(comInfo.realComId);
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            getContractTypeList: function () {
                let self = this;
                if (self.contractType == self.servcPurch.value) {
                    self.contract.typeId = self.servcPurch.value;
                    self.contract.typeName = self.servcPurch.text;
                } else if (self.contractType == self.integPurch.value) {
                    self.contract.typeId = self.integPurch.value;
                    self.contract.typeName = self.integPurch.text;
                } else if (self.contractType == self.servcDlgt.value) {
                    self.contract.typeId = self.servcDlgt.value;
                    self.contract.typeName = self.servcDlgt.text;
                }
            },
            //是否跨订单结算
            settleChange: function (settleCrossOrderAllowed) {
                if (!Utils.isNoB(this.contract.kindId) && this.contract.kindId == 0) {
                    if (settleCrossOrderAllowed) {
                        this.contract.phaseFlag = false;
                    } else {
                        this.contract.phaseFlag = true;
                    }
                }
            },
            showMerchantDlg() {
                let self = this;
                let params = {
                    multiSelect: false,
                    initCheckedId: self.contract.fstPartyId,
                    showContract: true, // 合同
                    showOrder: true, // 订单
                    showBizRel: true, // 备选
                    showAdverseBizRel: false, // 买方关联，备选其他
                    showNoScoreBizRel: false, // 带入围
                    showShieldedBizRel: false, // 加黑
                    showAll: true // 全部
                };
                if (self.contractType == self.servcDlgt.value) {
                    // 选择供应商
                    openVendorSelectComnDlg(params, function (returnData) {
                        self.selectMerchantResult(returnData);
                    });
                } else {
                    // 选择零售商
                    openRetailerSelectComnDlg(params, function (returnData, theDlg) {
                        theDlg.close();
                        self.selectMerchantResult(returnData);
                    });
                }
            },
            // 选择供应商、零售商返回结果处理
            selectMerchantResult: function (returnData) {
                let self = this;
                let merchant = returnData.checkedList || {};
                self.contract.fstPartyId = merchant.id;
                self.contract.fstPartyName = merchant.name;
                self.contract.fstPartyRealId = merchant.realId;
                self.contract.fstPartyRealComId = merchant.realComId;
                self.contract.fstPartyRealComName = merchant.realComName;
                if (self.contractType != self.servcDlgt.value) {
                    self.contract.fstPartyType = self.servcPurch.fstPartyType;
                    self.contract.callBidDocId = null;
                    self.contract.srcName = null;
                    self.contract.srcWinId = null;
                    self.contract.contractGoodsList = [];
                    self.contract.contractServcList = [];
                    self.disabledBtn = false;
                    self.forBid = null;
                } else {
                    self.contract.fstPartyType = self.servcDlgt.fstPartyType;
                }
                self.showBtn = true;
                self.getInvoiceTypeList(function () {
                    if (Utils.isNoB(self.contractId) && self.merchantInvoiceTypeList != null && self.merchantInvoiceTypeList.length > 0) {
                        self.checkInvoiceType(1);
                    }
                });
                self.getInvoiceContentTagList();
                let retailerMerchantType = getEnumInfoWith('merchantType', 'name', 'Retailer').value;
                if (self.contract.fstPartyType == retailerMerchantType) {
                    self.getMerchantBizParam(merchant.id);
                    self.getFiscalTaxMarkList(merchant.id);
                }
                //
                if (!Utils.isNoB(self.contract.invoiceType)) {
                    // 重新获取发票抬头
                    self.getMerchantInvoiceSubjectByOnly();
                }
            },
            // 获取零售商财务在账业务参数
            getMerchantBizParam: function (merchantId) {
                let self = this;
                let postData = {};
                postData.merchantId = merchantId;
                postData.merchantType = getEnumInfoWith('merchantType', 'name', 'Retailer').value;
                postData.code = "asset.finac.enabled";
                merchtComnApi.getMerchantBizParamValue(postData, function (result) {
                    if (result.type === "info") {
                        self.normalFlag = Utils.isTrue(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getFiscalTaxMarkList: function (merchantId) {
                let self = this;
                let postData = {};
                postData.merchantId = merchantId;

                let theLoad = MsgBox.loading();
                fiscalBizApi.getFiscalTaxMarkPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let fiscalTaxMarkList = result.data || [];
                        if (fiscalTaxMarkList.length > 0) {
                            fiscalTaxMarkList.forEach(function (item) {
                                item.rate = parseFloat(item.rate).toFixed(2)
                            })
                        }
                        self.fiscalTaxMarkList = fiscalTaxMarkList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            removeGoods: function (index) {
                let self = this;
                let contractGoodsList = self.contract.contractGoodsList;
                for (let i = 0; i < contractGoodsList.length; i++) {
                    if (i == index) {
                        contractGoodsList.remove(contractGoodsList[i]);
                    }
                }
                self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                //
                self.goodsAmountOrQuantityChange();
            },
            // 设置经营区域价格
            bizAreaOption: function (row, index) {
                let self = this;
                let params = {
                    operateContract: self.operateContract,
                    disabled: self.disabled,
                    taxRate: Utils.isNoB(self.contract.taxRate) ? null : parseFloat(self.contract.taxRate),
                    areaPrices: row.contractGoodsAreaPrices || [],
                    kindId: self.contract.kindId,
                    price: row.price
                };
                // 首次查询直接去数据库查询该条目的使用区域价格，之后就不查询了
                let queryBizAreaFlagMap = self.queryBizAreaFlagMap || {};
                let queryFlag = queryBizAreaFlagMap[index];
                if (Utils.isNoB(queryFlag)) {
                    params.contractGoodsItemId = row.id;
                    queryBizAreaFlagMap[index] = false;
                    self.queryBizAreaFlagMap = Utils.merge({}, queryBizAreaFlagMap);
                }
                openContractGoodsAreaPriceDlg(params, function (areaPriceList, theDlg) {
                    theDlg.close();
                    areaPriceList = areaPriceList || [];
                    row.contractGoodsAreaPrices = areaPriceList;
                    if (self.contract.kindId != null && self.contract.kindId == 0) {
                        let quantity = 0;
                        let amount = 0;
                        for (let i = 0; i < areaPriceList.length; i++) {
                            let areaPrice = areaPriceList[i];
                            quantity = quantity + parseInt(areaPrice.quantity);
                            amount = amount + parseFloat(areaPrice.amount);
                        }
                        row.quantity = quantity;
                        row.amount = amount.toFixed(2);
                    }
                    //
                    let estmtGoodsCount = 0;
                    let goodsAmount = 0;
                    let contractGoodsList = self.contract.contractGoodsList || [];
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        if (i == index) {
                            contractGoodsList[i] = row;
                        }
                        if (self.contract.kindId != null && self.contract.kindId == 0) {
                            estmtGoodsCount = estmtGoodsCount + parseInt(Utils.isNoB(contractGoodsList[i].quantity) ? 0 : contractGoodsList[i].quantity);
                            goodsAmount = goodsAmount + parseFloat(Utils.isNoB(contractGoodsList[i].amount) ? 0 : contractGoodsList[i].amount);
                        }
                    }
                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                    //
                    if (self.contract.kindId != null && self.contract.kindId == 0) {
                        self.goodsAmount = goodsAmount.toFixed(2);
                        self.contract.estmtAmount = (parseFloat(self.goodsAmount || 0) + parseFloat(self.servcAmount || 0)).toFixed(2);
                        self.contract.estmtGoodsCount = estmtGoodsCount;
                    }
                });
            },
            showMkuListDlg: function () {
                let self = this;
                let contract = self.contract;
                let contractGoodsList = contract.contractGoodsList;
                let skuIds = [];
                if (contractGoodsList != null && contractGoodsList.length > 0) {
                    for (let i = 0; i < contractGoodsList.length; i++) {
                        skuIds.push(contractGoodsList[i].skuId);
                    }
                }
                let filter = {};
                filter.merchantId = contract.sndPartyId;
                filter.merchantType = self.integPurch.sndPartyType;
                openSkuListSelectDlg(true, filter, skuIds, function (data) {
                    let resultData = data;
                    if (resultData != null && resultData.length > 0) {
                        for (let i = 0; i < resultData.length > 0; i++) {
                            let sku = resultData[i];
                            if (sku.goodsId != null && sku.title != null) {
                                let item = {};
                                item.mkuId = sku.mkuId;
                                item.skuId = sku.id;
                                item.model = sku.model;
                                item.fixedSpec = sku.fixedSpec;
                                item.name = sku.title;
                                item.title = item.name || '' + sku.fixedSpec || '';
                                item.goodsId = sku.goodsId;
                                item.catId = sku.catId;
                                item.catName = sku.catName;
                                item.brandId = sku.brandId;
                                item.brandName = sku.brandName;
                                if (sku.priceNegoFlag) {
                                    item.price = null;
                                } else {
                                    item.price = Utils.isNoB(sku.salePrice) ? null : parseFloat(sku.salePrice).toFixed(2);
                                }
                                item.taxRate = contract.taxRate || 0.00;
                                if (Utils.isNoB(item.price)) {
                                    item.ntxPrice = item.price;
                                } else {
                                    item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(item.taxRate) * 0.01))).toFixed(2);
                                }
                                item.bizAreaFlag = false;
                                item.wrntPeriod = sku.wrntPeriod;
                                item.unit = sku.unit;
                                item.fileBrowseUrl = sku.defaultImageUrl;
                                contractGoodsList.push(item);
                            }
                        }
                        self.sortContractGoods(contractGoodsList);
                        self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                    }
                });
            },
            // 商品排序
            sortContractGoods: function (contractGoodsList) {
                contractGoodsList = contractGoodsList || [];
                for (let i = 0; i < contractGoodsList.length > 0; i++) {
                    let contractGoods = contractGoodsList[i];
                    contractGoods.seqNo = i + 1;
                }
            },
            // 新增合同服务条目，comnRequire：为true代表常规服务请求，为false代表设备维保服务
            addContractServc: function (comnRequire) {
                let contractServc = {
                    devcGroupId: null,
                    devcGroupFullName: null,
                    innerDevcBrandName: null,
                    servcTypeId: null,
                    servcSpec: null,
                    title: null,
                    toDoorFee: null,
                    price: null,
                    rspTimeMi: null,
                    arriveTimeMi: null,
                    repairedTimeMi: null,
                    wrntPeriod: null,
                    telCallTimeMi: null,
                    quantity: null,
                    quantityRevisible: false,
                    timesLimitType: 0,
                    amount: null,
                    dateStart: null,
                    dateEnd: null,
                    desc: null
                };
                let contract = this.contract || {};
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    contractServc2List.push(contractServc);
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    // 设备维保服务
                    contractServc.devcPartsOnly = false;
                    contractServc.devcParts = null;
                    //
                    let contractServcList = contract.contractServcList || [];
                    contractServcList.push(contractServc);
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                this.contract = Utils.merge({}, contract);
            },
            // 设置特定门店价格
            setOrgPrice: function (index, comnRequire) {
                let self = this;
                let contract = this.contract || {};
                let contractAppliedShopList = contract.contractAppliedShopList || [];
                if (contractAppliedShopList.length <= 0) {
                    MsgBox.warning("请先选择适用机构");
                    return false;
                }
                let contractServc = {}
                if (comnRequire) {
                    contractServc = contract.contractServc2List[index] || {};
                } else {
                    contractServc = contract.contractServcList[index] || {};
                }
                let params = {
                    showDetail: !this.showSave,
                    servcPrice: contractServc.price || 0.00,
                    orgPriceList: contractServc.orgPriceList || [],
                    contractAppliedShopList: contractAppliedShopList,
                    filterMerchantId: contract.kindId == 0,
                    merchantId: contract.fstPartyId
                }
                openContractServcOrgPriceSetDlg(params, function (orgPriceList) {
                    contractServc.orgPriceList = Utils.merge([], orgPriceList);
                    //
                    if (comnRequire) {
                        contract.contractServc2List[index] = Utils.merge({}, contractServc);
                    } else {
                        contract.contractServcList[index] = Utils.merge({}, contractServc);
                    }
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 设置门店服务次数
            setOrgQuantity: function (index, comnRequire) {
                let self = this
                let contract = this.contract || {};
                let contractServc = {};
                if (comnRequire) {
                    contractServc = contract.contractServc2List[index] || {};
                } else {
                    contractServc = contract.contractServcList[index] || {};
                }
                if (contractServc.orgQuantityList.length <= 0) {
                    MsgBox.warning("请先选择适用机构");
                    return false;
                }
                let params = {
                    showDetail: !this.showSave,
                    orgQuantityList: Utils.merge([], contractServc.orgQuantityList)
                }
                openContractServcOrgQuantitySetDlg(params, function (orgQuantityList) {
                    contractServc.orgQuantityList = Utils.merge([], orgQuantityList);
                    //
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 设置服务特定
            setOrgSpecInfo: function (index, servcType, timesLimitType, quantityRevisible, comnRequire) {
                let self = this;
                let contract = this.contract || {};
                let contractAppliedShopList = contract.contractAppliedShopList || [];
                if (contractAppliedShopList.length <= 0) {
                    MsgBox.warning('请先选择适用机构');
                    return false;
                }
                let contractServc = {};
                if (comnRequire) {
                    contractServc = contract.contractServc2List[index] || {};
                } else {
                    contractServc = contract.contractServcList[index] || {};
                }
                let quantityFlag = timesLimitType == 1;     // 按门店设定次数：可设定服务次数。
                let amountFlag = timesLimitType == 1 && (servcType == 1 || servcType == 3 || servcType == 6);   // 【保养，检验，巡检】+ 按门店设定次数： 可设定总价
                let params = {
                    showDetail: !this.showSave,
                    bianengFlag: this.showSave && this.operateContract == 'change',
                    comnRequire: comnRequire,
                    quantityFlag: quantityFlag,
                    amountFlag: amountFlag,
                    quantityRevisible: quantityRevisible,
                    servcOrgSpecList: contractServc.servcOrgSpecList || [],
                    contractAppliedShopList: contractAppliedShopList,
                    filterMerchantId: contract.kindId == 0,
                    title: timesLimitType != 1 ? '设置特定门店价格' : '设置门店次数和价格',
                };
                openContractServcOrgSpecListDlg(params, function (servcOrgSpecList) {
                    contractServc.servcOrgSpecList = Utils.merge([], servcOrgSpecList);
                    //
                    if (comnRequire) {
                        contract.contractServc2List[index] = Utils.merge({}, contractServc);
                    } else {
                        contract.contractServcList[index] = Utils.merge({}, contractServc);
                    }
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 移除合同服务
            removeContractServc: function (index, comnRequire) {
                let contract = this.contract || {};
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    for (let i = 0; i < contractServc2List.length; i++) {
                        if (i == index) {
                            contractServc2List.splice(i, 1);
                            break;
                        }
                    }
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    // 设备维保服务
                    let contractServcList = contract.contractServcList || [];
                    for (let i = 0; i < contractServcList.length; i++) {
                        if (i == index) {
                            contractServcList.splice(i, 1);
                            break;
                        }
                    }
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                this.contract = Utils.merge({}, contract);
                //
                this.servcAmountOrQuantityChange();
            },
            // 选择服务项目
            showMsuListDlg: function (contractServc, index, comnRequire) {
                let self = this;
                let objectType = null;
                if (self.contractType != self.servcDlgt.value) {
                    objectType = self.servcPurch.sndPartyType;
                } else {
                    objectType = self.servcDlgt.fstPartyType;
                }
                let contract = self.contract || {};
                //
                Vue.$showDialog({
                    title: "选择服务",
                    showCloseBtn: true,
                    height: 700,
                    template: '<div >' +
                        '<swb-msu-list-for-select :checkBox="checkBox" :objectId="objectId" :objectType="objectType" :checkedIds="childEventList" :type="type" :proxied="proxied" :comnOnlyFlag="comnOnlyFlag" ref="swb_msu_list"></swb-msu-list-for-select>' +
                        '</div>',
                    data: {
                        checkBox: false,
                        childEventList: [],
                        objectId: null,
                        objectType: objectType,
                        proxied: false,
                        type: contractServc.servcTypeId,
                        comnOnlyFlag: comnRequire
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_msu_list.getDlgResult() || {};
                        if (result !== null) {
                            if (result.type === 'info') {
                                let msu = result.data;
                                if (!Utils.isNoB(msu) && msu.servcId > 0 && !Utils.isNoB(msu.title)) {
                                    if (Utils.isTrue(comnRequire)) {
                                        // 常规服务请求
                                        let contractServc2List = contract.contractServc2List || [];
                                        let servcList = Utils.merge([], contractServc2List);
                                        let contractServc2 = contractServc2List[index];
                                        contractServc2.ssuId = msu.ssuId;
                                        contractServc2.name = msu.title;
                                        contractServc2.fixedSpec = msu.fixedSpec;
                                        contractServc2.title = contractServc2.name || '' + msu.fixedSpec || '';
                                        contractServc2.servcId = msu.servcId;
                                        if (Utils.isNoB(contract.id) || contract.id <= 0) {
                                            if (Utils.isNoB(contractServc2.wrntPeriod)) {
                                                contractServc2.wrntPeriod = msu.wrntPeriod;
                                            }
                                            if (Utils.isNoB(contractServc2.toDoorFee)) {
                                                contractServc2.toDoorFee = Utils.isNoB(msu.toDoorFee) ? null : parseFloat(msu.toDoorFee).toFixed(2);
                                            }
                                            if (Utils.isNoB(contractServc2.price)) {
                                                contractServc2.price = Utils.isNoB(msu.generallFee) ? null : parseFloat(msu.generallFee).toFixed(2);
                                            }
                                            if (Utils.isNoB(contractServc2.rspTimeMi)) {
                                                contractServc2.rspTimeMi = msu.rspTimeMi;
                                            }
                                            if (Utils.isNoB(contractServc2.arriveTimeMi)) {
                                                contractServc2.arriveTimeMi = msu.arriveTimeMi;
                                            }
                                            if (Utils.isNoB(contractServc2.repairedTimeMi)) {
                                                contractServc2.repairedTimeMi = msu.repairedTimeMi;
                                            }
                                            if (Utils.isNoB(contractServc2.telCallTimeMi)) {
                                                contractServc2.telCallTimeMi = msu.telCallTimeMi;
                                            }
                                        }
                                        if (Utils.isNoB(contractServc2.dateStart)) {
                                            contractServc2.dateStart = null;
                                        }
                                        if (Utils.isNoB(contractServc2.dateEnd)) {
                                            contractServc2.dateEnd = null;
                                        }
                                        let errMsg = self.checkContractServcItem(contractServc2, servcList, comnRequire);
                                        if (!Utils.isNoB(errMsg)) {
                                            MsgBox.warning(errMsg);
                                            return false;
                                        }
                                        contract.contractServc2List = Utils.merge([], contractServc2List);
                                        self.contract = Utils.merge({}, contract);
                                    } else {
                                        // 设备维保服务
                                        let contractServcList = contract.contractServcList || [];
                                        let servcList = Utils.merge([], contractServcList);
                                        let contractServcInfo = contractServcList[index];
                                        contractServcInfo.ssuId = msu.ssuId;
                                        contractServcInfo.name = msu.title;
                                        contractServcInfo.fixedSpec = msu.fixedSpec;
                                        contractServcInfo.title = contractServcInfo.name || '' + msu.fixedSpec || '';
                                        contractServcInfo.servcId = msu.servcId;
                                        if (Utils.isNoB(contract.id) || contract.id <= 0) {
                                            if (Utils.isNoB(contractServcInfo.wrntPeriod)) {
                                                contractServcInfo.wrntPeriod = msu.wrntPeriod;
                                            }
                                            if (Utils.isNoB(contractServcInfo.toDoorFee)) {
                                                contractServcInfo.toDoorFee = Utils.isNoB(msu.toDoorFee) ? null : parseFloat(msu.toDoorFee).toFixed(2);
                                            }
                                            if (Utils.isNoB(contractServcInfo.price)) {
                                                contractServcInfo.price = Utils.isNoB(msu.generallFee) ? null : parseFloat(msu.generallFee).toFixed(2);
                                            }
                                            if (Utils.isNoB(contractServcInfo.rspTimeMi)) {
                                                contractServcInfo.rspTimeMi = msu.rspTimeMi;
                                            }
                                            if (Utils.isNoB(contractServcInfo.arriveTimeMi)) {
                                                contractServcInfo.arriveTimeMi = msu.arriveTimeMi;
                                            }
                                            if (Utils.isNoB(contractServcInfo.repairedTimeMi)) {
                                                contractServcInfo.repairedTimeMi = msu.repairedTimeMi;
                                            }
                                            if (Utils.isNoB(contractServcInfo.telCallTimeMi)) {
                                                contractServcInfo.telCallTimeMi = msu.telCallTimeMi;
                                            }
                                        }
                                        if (Utils.isNoB(contractServcInfo.dateStart)) {
                                            contractServcInfo.dateStart = null;
                                        }
                                        if (Utils.isNoB(contractServcInfo.dateEnd)) {
                                            contractServcInfo.dateEnd = null;
                                        }
                                        let errMsg = self.checkContractServcItem(contractServcInfo, servcList, comnRequire);
                                        if (!Utils.isNoB(errMsg)) {
                                            MsgBox.warning(errMsg);
                                            return false;
                                        }
                                        contract.contractServcList = Utils.merge([], contractServcList);
                                        self.contract = Utils.merge({}, contract);
                                    }
                                    self.contract.servcFlag = true;
                                    if (self.contractType != self.integPurch.value) {
                                        self.contract.goodsFlag = false;
                                    }
                                    return true;
                                }
                            } else {
                                MsgBox.warning(result.message);
                            }
                        } else {
                            MsgBox.warning("返回出错");
                        }
                        return false;
                    },
                    methods: {},
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            let servc = self.contract.contractServcList;
                            let msuIds = [];
                            if (servc && servc.length > 0) {
                                for (var i = 0; i < servc.length; i++) {
                                    msuIds.push(servc[i].ssuId);
                                }
                            }
                            selfDlg.childEventList = msuIds;

                            if (self.contractType == self.servcDlgt.value) {
                                selfDlg.proxied = true;
                                selfDlg.objectId = self.contract.fstPartyId;
                            } else {
                                selfDlg.objectId = self.contract.sndPartyId;
                            }
                        }
                    }
                });
            },
            // 校验合同服务条目
            checkContractServcItem: function (contractServc, servcList, comnRequire) {
                let errMsg = '';
                servcList = servcList || [];
                for (let i = 0; i < servcList.length; i++) {
                    let contractServcInfo = servcList[i];
                    if (Utils.isTrue(comnRequire)) {
                        // 常规服务请求
                        if (contractServc.comnRequireId > 0 && contractServcInfo.comnRequireId == contractServc.comnRequireId //
                            && !Utils.isNoB(contractServc.servcTypeId) && !Utils.isNoB(contractServcInfo.servcTypeId) && parseInt(contractServcInfo.servcTypeId) == parseInt(contractServc.servcTypeId) //
                            && !Utils.isNoB(contractServc.ssuId) && contractServc.ssuId > 0 && !Utils.isNoB(contractServcInfo.ssuId) && parseInt(contractServcInfo.ssuId) == parseInt(contractServc.ssuId)
                        ) {
                            errMsg = '有重复的常规服务请求条目！';
                            break;
                        }
                    } else {
                        // 设备维保服务
                        let goodsCatId = contractServc.goodsCatId;
                        if (Utils.isNoB(goodsCatId)) {
                            goodsCatId = -1;
                        }
                        let goodsCatIdX = contractServcInfo.goodsCatId;
                        if (Utils.isNoB(goodsCatIdX)) {
                            goodsCatIdX = -1;
                        }
                        if (contractServc.devcGroupId > 0 && contractServcInfo.devcGroupId == contractServc.devcGroupId //
                            && goodsCatId == goodsCatIdX //
                            && !Utils.isNoB(contractServc.servcTypeId) && !Utils.isNoB(contractServcInfo.servcTypeId) && parseInt(contractServcInfo.servcTypeId) == parseInt(contractServc.servcTypeId) //
                            && !Utils.isNoB(contractServc.ssuId) && contractServc.ssuId > 0 && !Utils.isNoB(contractServcInfo.ssuId) && parseInt(contractServcInfo.ssuId) == parseInt(contractServc.ssuId) //
                            && contractServc.devcPartsOnly == contractServcInfo.devcPartsOnly && contractServc.devcParts == contractServcInfo.devcParts
                        ) {
                            errMsg = '有重复的设备维保服务条目！';
                            break;
                        }
                    }
                }
                return errMsg;
            },
            timeMiCheck: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空!'));
                } else {
                    if (Utils.isNaturalStr(value, true) && value >= 0) {
                        callback();
                    } else {
                        callback(new Error('必须为大于等于0的整数!'));
                    }
                }
            },
            quantityCheck: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空!'));
                } else {
                    if (Utils.isNaturalStr(value, true) && value >= 0) {
                        callback();
                    } else {
                        callback(new Error('必须为大于等于0的整数!'));
                    }
                }
            },
            // 费用校验
            moneyCheck: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    if (!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 上门费变化事件
            toDoorFeeChange: function (index, comnRequire) {
                let contract = this.contract;
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    let contractServc2 = contractServc2List[index];
                    contractServc2.toDoorFee = Utils.isNoB(contractServc2.toDoorFee) ? null : parseFloat(contractServc2.toDoorFee).toFixed(2);
                    contractServc2.amount = ((parseFloat(contractServc2.price || 0) + parseFloat(contractServc2.toDoorFee || 0)) * parseInt(contractServc2.quantity || 0)).toFixed(2);
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    // 设备维保服务
                    let contractServcList = contract.contractServcList || [];
                    let contractServc = contractServcList[index];
                    contractServc.toDoorFee = Utils.isNoB(contractServc.toDoorFee) ? null : parseFloat(contractServc.toDoorFee).toFixed(2);
                    contractServc.amount = ((parseFloat(contractServc.price || 0) + parseFloat(contractServc.toDoorFee || 0)) * parseInt(contractServc.quantity || 0)).toFixed(2);
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                //
                this.contract = Utils.merge({}, contract);
                this.servcAmountOrQuantityChange();
            },
            // 服务费变化事件
            priceChange: function (index, comnRequire) {
                let contract = this.contract;
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    let contractServc2 = contractServc2List[index];
                    contractServc2.price = Utils.isNoB(contractServc2.price) ? null : parseFloat(contractServc2.price).toFixed(2);
                    contractServc2.amount = ((parseFloat(contractServc2.price || 0) + parseFloat(contractServc2.toDoorFee || 0)) * parseInt(contractServc2.quantity || 0)).toFixed(2);
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    // 设备维保服务
                    let contractServcList = contract.contractServcList || [];
                    let contractServc = contractServcList[index];
                    contractServc.price = Utils.isNoB(contractServc.price) ? null : parseFloat(contractServc.price).toFixed(2);
                    contractServc.amount = ((parseFloat(contractServc.price || 0) + parseFloat(contractServc.toDoorFee || 0)) * parseInt(contractServc.quantity || 0)).toFixed(2);
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                //
                this.contract = Utils.merge({}, contract);
                this.servcAmountOrQuantityChange();
            },
            // 服务次数变化事件
            quantityChange: function (index, comnRequire) {
                let contract = this.contract;
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    let contractServc2 = contractServc2List[index];
                    if (!Utils.isNoB(contractServc2.usedQuantity) && contractServc2.usedQuantity > 0 && contractServc2.quantity < contractServc2.usedQuantity) {
                        MsgBox.warning('不可小于已发生次数');
                        return;
                    }
                    contractServc2.amount = ((parseFloat(contractServc2.price || 0) + parseFloat(contractServc2.toDoorFee || 0)) * parseInt(contractServc2.quantity || 0)).toFixed(2);
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    // 设备维保服务
                    let contractServcList = contract.contractServcList || [];
                    let contractServc = contractServcList[index];
                    if (!Utils.isNoB(contractServc.usedQuantity) && contractServc.usedQuantity > 0 && contractServc.quantity < contractServc.usedQuantity) {
                        MsgBox.warning('不可小于已发生次数');
                        return;
                    }
                    contractServc.amount = ((parseFloat(contractServc.price || 0) + parseFloat(contractServc.toDoorFee || 0)) * parseInt(contractServc.quantity || 0)).toFixed(2);
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                //
                this.contract = Utils.merge({}, contract);
                this.servcAmountOrQuantityChange();
            },
            // 服务次数
            timesLimitTypeChange: function (index, comnRequire) {
                let self = this;
                let contract = self.contract || {};
                let contractServcList = contract.contractServcList || [];
                let contractServc2List = contract.contractServc2List || [];
                let contractServc = {};
                if (comnRequire) {
                    contractServc = contractServc2List[index];
                } else {
                    contractServc = contractServcList[index];
                }
                if (contractServc.timesLimitType == 1) {
                    let contractAppliedShopList = contract.contractAppliedShopList || [];
                    let orgQuantityList = [];
                    if (contractAppliedShopList.length > 0) {
                        for (let i = 0; i < contractAppliedShopList.length; i++) {
                            let contractAppliedShop = contractAppliedShopList[i];
                            orgQuantityList.push({
                                bizUnitId: contractAppliedShop.shopId,
                                bizUnitName: contractAppliedShop.shopName,
                                shopFlag: contractAppliedShop.shopFlag,
                                bizAreaId: contractAppliedShop.bizAreaId,
                                bizAreaName: contractAppliedShop.bizAreaName,
                                bizFormId: contractAppliedShop.bizFormId,
                                bizFormName: contractAppliedShop.bizFormName,
                                mgmtSmlAreaId: contractAppliedShop.mgmtSmlAreaId,
                                mgmtSmlAreaName: contractAppliedShop.mgmtSmlAreaName,
                            });
                        }
                        contractServc.orgQuantityList = Utils.merge([], orgQuantityList);
                    }
                } else {
                    contractServc.orgQuantityList = [];
                }
                contractServc.quantity = 0;
                contractServc.amount = 0.00;
                if (comnRequire) {
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                } else {
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                self.contract = Utils.merge({}, contract);
            },
            //
            registerContract: function () {
                let self = this;
                let isValid = Utils.repeatChecker.isValidFor("registerContract", 1000);
                if (!isValid) {
                    return;
                }
                let contract = self.contract;
                if (Utils.isTrue(contract.useAccAuditRule) && !Utils.isTrue(contract.sglAccAuditEnabled) && !Utils.isTrue(contract.sumAccAuditEnabled)) {
                    MsgBox.warning("至少选择一个配件审核规则");
                    return;
                }
                if (Utils.isNoB(contract.invoiceType)) {
                    MsgBox.warning("发票信息[发票类型]不可为空");
                    return;
                }
                if (Utils.isNoB(contract.taxPayerNo)) {
                    MsgBox.warning("发票信息[纳税人识别号]不可为空");
                    return;
                }
                self.$refs['contract'].validate(function (valid) {
                    if (valid) {
                        let contractServcList = contract.contractServcList || [];
                        let contractServc2List = contract.contractServc2List || [];
                        if (contractServcList.length <= 0 && contractServc2List.length <= 0) {
                            MsgBox.warning("请设置设备维保服务或者常规服务请求信息！");
                            return false;
                        }
                        let errFlag = false;
                        if (contractServcList.length > 0) {
                            for (let i = 0; i < contractServcList.length; i++) {
                                let contractServc = contractServcList[i];
                                if (!Utils.isNoB(contractServc.dateStart)) {
                                    contractServc.dateStart = contractServc.dateStart.format('yyyy-MM-dd');
                                }
                                if (!Utils.isNoB(contractServc.dateEnd)) {
                                    contractServc.dateEnd = contractServc.dateEnd.format('yyyy-MM-dd');
                                }
                                if (Utils.isNoB(contractServc.ssuId) || contractServc.ssuId <= 0 || Utils.isNoB(contractServc.servcId) || contractServc.servcId <= 0) {
                                    let msg = "请为服务【" + contractServc.title + "】设置服务项目！";
                                    if (Utils.isNoB(contractServc.title)) {
                                        msg = "请为设备维保服务中的服务设置服务项目！";
                                    }
                                    errFlag = true;
                                    MsgBox.warning(msg);
                                    return false;
                                }
                            }
                            if (Utils.isTrue(errFlag)) {
                                return;
                            }
                            self.$refs['contractServcList'].validate(function (valid) {
                                if (!valid) {
                                    errFlag = true;
                                    MsgBox.warning("请设置设备维保服务相关信息！");
                                    return false;
                                }
                            });
                            if (Utils.isTrue(errFlag)) {
                                return;
                            }
                        }
                        if (contractServc2List.length > 0) {
                            for (let i = 0; i < contractServc2List.length; i++) {
                                let contractServc = contractServc2List[i];
                                if (!Utils.isNoB(contractServc.dateStart)) {
                                    contractServc.dateStart = contractServc.dateStart.format('yyyy-MM-dd');
                                }
                                if (!Utils.isNoB(contractServc.dateEnd)) {
                                    contractServc.dateEnd = contractServc.dateEnd.format('yyyy-MM-dd');
                                }
                                //
                                if (Utils.isNoB(contractServc.ssuId) || contractServc.ssuId <= 0 || Utils.isNoB(contractServc.servcId) || contractServc.servcId <= 0) {
                                    let msg = "请为服务【" + contractServc.title + "】设置服务项目！";
                                    if (Utils.isNoB(contractServc.title)) {
                                        msg = "请为常规服务请求中的服务设置服务项目！";
                                    }
                                    errFlag = true;
                                    MsgBox.warning(msg);
                                    return false;
                                }
                            }
                            if (Utils.isTrue(errFlag)) {
                                return;
                            }
                            self.$refs['contractServc2List'].validate(function (valid) {
                                if (!valid) {
                                    errFlag = true;
                                    MsgBox.warning("请设置常规服务请求相关信息！");
                                    return false;
                                }
                            });
                            if (Utils.isTrue(errFlag)) {
                                return;
                            }
                        }
                        if (Utils.isTrue(contract.servcAmountFixed) && !Utils.isNoB(self.contract.kindId) && self.contract.kindId == 0) {
                            if (Utils.isNoB(contract.totalServcAmount) || !Utils.isMoneyStr(contract.totalServcAmount) || contract.totalServcAmount < 0) {
                                MsgBox.warning("请输入正确的服务包死价总额！");
                                return;
                            }
                        }
                        if (self.contractType == self.integPurch.value) {
                            if (contract.contractGoodsList.length == 0) {
                                MsgBox.warning("无商品信息！");
                                return false;
                            }
                            let goodsFlag = false;
                            self.$refs['contractGoodsList'].validate(function (valid) {
                                if (valid) {
                                    let contractGoodsList = contract.contractGoodsList || [];
                                    for (let i = 0; i < contractGoodsList.length; i++) {
                                        let contractGoods = contractGoodsList[i];
                                        if (Utils.isTrue(contractGoods.bizAreaFlag)) {
                                            let contractGoodsAreaPrices = contractGoods.contractGoodsAreaPrices || [];
                                            if (contractGoodsAreaPrices.length <= 0) {
                                                MsgBox.warning("请为商品【" + contractGoods.title + "】设置区域价格！");
                                                return false;
                                            }
                                        } else {
                                            let quantity = contractGoods.quantity;
                                            if (Utils.isNoB(quantity) && !Utils.isNoB(self.contract.kindId) && self.contract.kindId == 0) {
                                                MsgBox.warning("请为商品【" + contractGoods.title + "】设置具体的商品数量！");
                                                return false;
                                            }
                                            let price = contractGoods.price;
                                            if (Utils.isNoB(price)) {
                                                MsgBox.warning("请为商品【" + contractGoods.title + "】设置具体的含税价！");
                                                return false;
                                            }
                                        }
                                    }
                                    goodsFlag = true;
                                }
                            });
                            if (!goodsFlag) {
                                return false;
                            }
                        }
                        if (self.contractType != self.servcDlgt.value && !Utils.isNoB(self.contract.kindId) && self.contract.kindId == 0) {
                            if (Utils.isNoB(contract.estmtAmount) || !Utils.isMoneyStr(contract.estmtAmount) || contract.estmtAmount < 0) {
                                MsgBox.warning("请输入正确的预计合同总额！");
                                return;
                            }
                        }
                        let result = self.$refs.swb_contract_file.getDlgResult() || [];
                        if (result.type == "info") {
                            contract.contractFileList = result.data;
                        }
                        if (self.contractType != self.servcDlgt.value && contract.termsFlag) {
                            let ruleResult = self.$refs.swb_create_trade_rule.getResult() || [];
                            if (ruleResult.type == "info") {
                                let srcFlag = contract.srcFlag;
                                if (srcFlag == 2) {
                                    contract.contractTermList = ruleResult.data;
                                    let contractTermList = contract.contractTermList;
                                    for (let i = 0; i < contractTermList.length; i++) {
                                        let bidTermValueList = contractTermList[i].bidTermValueList;
                                        if (bidTermValueList != null) {
                                            contractTermList[i].contractTermValueList = Utils.copyAsArray(contractTermList[i].bidTermValueList);
                                        }
                                    }
                                } else if (srcFlag == 3) {
                                    contract.contractTermList = ruleResult.data;
                                    let contractTermList = contract.contractTermList;
                                    for (let i = 0; i < contractTermList.length; i++) {
                                        let priceReplyTermValueList = contractTermList[i].priceReplyTermValueList;
                                        if (priceReplyTermValueList != null) {
                                            contractTermList[i].contractTermValueList = Utils.copyAsArray(contractTermList[i].priceReplyTermValueList);
                                        }
                                    }
                                } else {
                                    contract.contractTermList = ruleResult.data;
                                }
                            } else {
                                return;
                            }
                        }
                        contract.signDate = contract.signDate.format('yyyy-MM-dd');
                        contract.dateStart = contract.dateStart.format('yyyy-MM-dd');
                        contract.dateEnd = contract.dateEnd.format('yyyy-MM-dd');
                        if (contract.dateStart >= contract.dateEnd) {
                            MsgBox.warning("请输入有效的合同开始结束时间");
                            return;
                        }
                        if (contract.estmtAmount == null) {
                            contract.estmtAmount = 0;
                        }
                        if (self.contractType != self.servcDlgt.value && contract.phaseFlag) {
                            // 获取合同履约阶段
                            let phaseResult = self.$refs.swb_contract_track_phase.getDlgResult();
                            if (phaseResult.type == "info") {
                                let contractTrackPhaseList = phaseResult.data;
                                let amountPayPctSum = 0;
                                let goodsDeliverCountPctSum = 0;
                                let amountPaySum = 0;
                                let goodsDeliverCountSum = 0;
                                if (contractTrackPhaseList != null && contractTrackPhaseList.length > 0) {
                                    for (let i = 0; i < contractTrackPhaseList.length; i++) {
                                        let contractTrackPhase = contractTrackPhaseList[i];
                                        //
                                        let amountPayPct = contractTrackPhase.amountPayPct || 0;
                                        let goodsDeliverCountPct = contractTrackPhase.goodsDeliverCountPct || 0;
                                        amountPayPctSum += Utils.ParseFloat(amountPayPct);
                                        goodsDeliverCountPctSum += Utils.ParseFloat(goodsDeliverCountPct);
                                        //
                                        let amountPay = contractTrackPhase.amountPay || 0;
                                        let goodsDeliverCount = contractTrackPhase.goodsDeliverCount || 0;
                                        amountPaySum += amountPay;
                                        goodsDeliverCountSum += goodsDeliverCount;
                                    }
                                    if (amountPayPctSum > 100 && amountPaySum > contract.estmtAmount) {
                                        MsgBox.warning("支付金额百分比不能超过100%！");
                                        return;
                                    }
                                    if (goodsDeliverCountPctSum > 100 && goodsDeliverCountSum > contract.estmtGoodsCount) {
                                        MsgBox.warning("商品交付件数百分比不能超过100%！");
                                        return;
                                    }
                                    contract.contractTrackPhaseList = contractTrackPhaseList;
                                } else {
                                    MsgBox.warning("请设置履约阶段！");
                                    return;
                                }
                            } else {
                                return;
                            }
                        }
                        //
                        if (Utils.isNoB(contract.id)) {
                            let postData = {};
                            postData.merchantId = contract.fstPartyId;
                            postData.merchantType = contract.fstPartyType;
                            merchtQualiApi.existMerchtQualiTrade(postData, function (result) {
                                if (result.type == 'info') {
                                    let existTrade = result.data;
                                    if (existTrade) {
                                        self.contract = Utils.merge({}, contract);
                                        self.saveContract();
                                    } else {
                                        MsgBox.warning("买家平台交易资质未认证，相关业务不能执行！");
                                    }
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        } else {
                            self.contract = Utils.merge({}, contract);
                            self.saveContract();
                        }
                    }
                });
            },
            saveContract: function () {
                let self = this;
                self.flag = false;
                let postData = {};
                postData = self.contract;

                if (postData.version == null) {
                    postData.version = 1;
                }
                if (self.operateContract == 'change') {
                    postData.id = null;
                    let version = postData.version;
                    postData.version = version + 1;
                }
                let path = "";
                if (self.contractType == self.servcPurch.value) {
                    path = SwbServcPurchContractList.path;
                } else if (self.contractType == self.servcDlgt.value) {
                    path = SwbServcDlgtContractList.path;
                } else if (self.contractType == self.integPurch.value) {
                    path = IntegPurchContractList.path;
                }
                if (postData.id != null) {
                    let theLoad = MsgBox.loading("数据修改中.....");
                    // postData.dirty = true;
                    contractApi.updateContractInfo(postData, function (result) {
                        if (result.type == "info") {
                            MsgBox.success("修改成功");
                            self.$router.push({
                                path: path
                            });
                        } else {
                            MsgBox.warning(result.message);
                        }
                        theLoad.hide();
                    });
                } else {
                    let theLoad = MsgBox.loading("数据登记中.....");
                    contractApi.registContract(postData, function (result) {
                        if (result.type == "info") {
                            MsgBox.success("登记成功");
                            self.$router.push({
                                path: path
                            });
                        } else {
                            MsgBox.warning(result.message);
                        }
                        theLoad.hide();
                    });
                }
            },
            prevContract: function () {
                let self = this;
                self.$router.back(-1);
            },
            getContractById: function (contractId) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                //
                contractApi.getContractInfo(postData, function (result) {
                    if (result.type == "info") {
                        let contract = result.data || {};
                        //
                        if (contract.contractDigest == null) {
                            let contractDigest = {content: null};
                            contract.contractDigest = contractDigest;
                        }
                        let operation = self.operateContract;
                        if (operation != 'chakan') {
                            // contract.dirty = true;
                        }
                        // if (operation == 'change') {
                        //     contract.sndPartyHtBh = null;
                        // }
                        if (contract.srcWinId != null || contract.srcWinId != null) {
                            self.disabledBtn = true;
                        } else {
                            self.disabledBtn = false;
                        }
                        //
                        contract.taxRate = Utils.isNoB(contract.taxRate) ? 0.00 : parseFloat(contract.taxRate).toFixed(2);
                        let contractGoodsList = contract.contractGoodsList;
                        for (let i = 0; i < contractGoodsList.length; i++) {
                            let item = contractGoodsList[i];
                            let taxRate = item.taxRate;
                            if (Utils.isNoB(taxRate)) {
                                taxRate = 0.00;
                                item.ntxPrice = Utils.isNoB(item.price) ? 0.00 : parseFloat(item.price).toFixed(2);
                            } else {
                                taxRate = parseFloat(taxRate).toFixed(2);
                                if (Utils.isNoB(item.price)) {
                                    item.ntxPrice = null;
                                } else {
                                    item.ntxPrice = (parseFloat(item.price) / (1 + (parseFloat(taxRate) * 0.01))).toFixed(2);
                                }
                            }
                            item.taxRate = taxRate;
                            item.price = Utils.isNoB(item.price) ? 0.00 : parseFloat(item.price).toFixed(2);
                            //
                            let bizFormNames = item.bizFormNames;
                            if (!Utils.isNoB(bizFormNames)) {
                                let bizFormNameList = [];
                                if (!Utils.isNoB(bizFormNames)) {
                                    if (bizFormNames.indexOf("|") >= 0) {
                                        bizFormNames = bizFormNames.substring(1, bizFormNames.length - 1);
                                        bizFormNameList = bizFormNames.split("|") || [];
                                    }
                                }
                                item.bizFormNameList = bizFormNameList;
                            }
                        }
                        contract.contractGoodsList = Utils.merge([], contractGoodsList);
                        if (!Utils.isNoB(contract.estmtAmount)) {
                            contract.estmtAmount = parseFloat(contract.estmtAmount).toFixed(2);
                        }
                        self.contract = Utils.merge({}, contract);

                        let contractTermList = self.contract.contractTermList;
                        if (contractTermList != null && contractTermList.length > 0) {
                            self.comparedTradeRuleList = contractTermList;
                            self.$refs.swb_create_trade_rule.getTradeRule();
                        }

                        /*if(self.contract.fstPartyConfirmed == true){
                         if(self.tradeOperate != 'change'){
                         self.tradeOperate = "chakan";
                         }
                         if(self.contract.contractGoodsList.length > 0){
                         self.showBtn = false;
                         }
                         if(self.contract.contractServcList.length > 0){
                         self.showBtn = false;
                         }
                         }
                         */
                        if (contract.version > 1) {
                            self.getPrevContract(contract.prevNo);
                        }
                        if (!Utils.isNoB(contract.servcType)) {
                            self.servcType = contract.servcType;
                        }

                        self.showUpload = true;
                        self.getInvoiceTypeList();
                        self.getInvoiceContentTagList();
                        self.setGoodsAndServcAmount();
                        let retailerMerchantType = getEnumInfoWith('merchantType', 'name', 'Retailer').value;
                        if (self.contract.fstPartyType == retailerMerchantType) {
                            self.getMerchantBizParam(self.contract.fstPartyId);
                            self.getFiscalTaxMarkList(self.contract.fstPartyId);
                        }
                    }
                });
            },
            getPrevContract: function (no) {
                let self = this;
                let postData = {};
                postData.no = no;
                //
                contractApi.getContractInfo(postData, function (result) {
                    if (result.type == "info") {
                        self.prevChangeContract = result.data;
                    }
                });
            },
            showCallBidDocDlg: function () {
                let self = this;
                let type = null;
                if (self.contractType == self.integPurch.value) {
                    type = 'goodsAndServc';
                }
                Vue.$showDialog({
                    title: '投标书信息',
                    width: '75%',
                    height: 700,
                    showCloseBtn: true,
                    template: '<div>' +
                        '<swb-bid-doc-for-select :rowId = "rowId" :isMultiple = "isMultiple" :empty = "empty" :type="type" ref="swb_bidDoc_select"></swb-bid-doc-for-select>' +
                        '</div>',
                    data: {
                        isMultiple: false,
                        empty: false,
                        rowId: null,
                        type: type
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_bidDoc_select.getDlgResult() || {};
                        if (result.type === 'info') {
                            let bidDoc = result.data;
                            if (bidDoc.id != null) {
                                self.contract.srcId = bidDoc.callDocId;
                                self.contract.srcName = bidDoc.title;
                                self.contract.srcWinId = bidDoc.id;
                                self.contract.srcFixed = true;
                                self.contract.estmtAmount = bidDoc.offerPrice;

                                self.contract.fstPartyId = bidDoc.fstPartyId;
                                self.contract.fstPartyType = bidDoc.fstPartyType;
                                self.contract.fstPartyName = bidDoc.fstPartyName;

                                let sumQuantity = 0;
                                let sumAmount = 0;
                                if (self.contractType == self.integPurch.value) {
                                    let bidGoodsList = bidDoc.bidGoodsList;
                                    let contractGoodsList = self.contract.contractGoodsList;
                                    contractGoodsList = [];
                                    if (bidGoodsList != null && bidGoodsList.length > 0) {
                                        for (var i = 0; i < bidGoodsList.length; i++) {
                                            let bidGood = bidGoodsList[i];
                                            let item = {};
                                            item.skuId = bidGood.skuId;
                                            item.name = bidGood.name;
                                            item.goodsId = bidGood.goodsId;
                                            item.brandId = bidGood.brandId;
                                            item.brandName = bidGood.brandName;
                                            item.wrntPeriod = bidGood.wrntPeriod;
                                            item.unit = bidGood.callUnit;
                                            item.price = bidGood.price;
                                            item.quantity = bidGood.callQuantity;
                                            if (bidGood.callQuantity != null) {
                                                sumQuantity += bidGood.callQuantity;
                                            }
                                            if (bidGood.price != null && bidGood.callQuantity != null) {
                                                sumAmount += bidGood.callQuantity * bidGood.price;
                                            }

                                            item.fileBrowseUrl = bidGood.skuDefaultImageUrl;

                                            contractGoodsList.push(item);
                                        }
                                    }
                                    self.contract.estmtGoodsCount = sumQuantity;
                                    self.contract.goodsFlag = true;
                                    self.contract.contractGoodsList = Utils.merge([], contractGoodsList);
                                }

                                let bidServcList = bidDoc.bidServcList;
                                let contractServcList = self.contract.contractServcList;
                                contractServcList = [];
                                if (bidServcList != null && bidServcList.length > 0) {
                                    for (var i = 0; i < bidServcList.length; i++) {
                                        let bidServc = bidServcList[i];
                                        let item = {};
                                        item.ssuId = bidServc.ssuId;
                                        item.name = bidServc.name;
                                        item.servcId = bidServc.servcId;
                                        item.wrntPeriod = bidServc.wrntPeriod;
                                        item.price = bidServc.price;
                                        item.dateStart = null;
                                        item.dateEnd = null;

                                        contractServcList.push(item);
                                    }
                                }
                                self.contract.servcFlag = true;
                                if (self.contractType != self.integPurch.value) {
                                    self.contract.goodsFlag = false;
                                }
                                self.contract.estmtAmount = sumAmount;
                                self.contract.contractServcList = Utils.merge([], contractServcList);

                                self.disabledBtn = true;
                                self.showAmtAndCot = false;
                                self.getInvoiceTypeList();
                                self.getInvoiceContentTagList();

                                //获取中标书的交易规则
                                let postData = {};
                                postData.docId = bidDoc.id;
                                tendBidApi.getBidTermList(postData, function (result) {
                                    if (result.type == 'info') {
                                        let bidTermList = result.data;
                                        if (bidTermList != null && bidTermList.length > 0) {
                                            self.comparedTradeRuleList = bidTermList;
                                            self.tradeType = "bid";
                                            self.forBid = true;
                                            self.$refs.swb_create_trade_rule.getTradeRule();
                                        }
                                    }
                                });
                            }
                            return true;
                        }
                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.rowId = self.contract.srcWinId;
                        }
                    }
                });
            },
            deleteCall: function () {
                let contract = this.contract;
                contract.srcId = null;
                contract.srcName = null;
                contract.srcWinId = null;
                contract.srcFixed = null;
                contract.contractGoodsList = [];
                contract.fstPartyId = null;
                contract.fstPartyName = null;
                contract.estmtAmount = null;
                contract.estmtGoodsCount = null;
                this.showAmtAndCot = true;
                this.disabledBtn = false;
                this.showBtn = false;
                this.comparedTradeRuleList = [];
                this.tradeType = null;
                this.forBid = null;
                this.$refs.swb_create_trade_rule.getTradeRule();
                contract.invoiceType = null;
                contract.invoiceTitle = null;
                contract.taxPayerNo = null;
                //    contract.invoiceContentTag = null;
                this.invoiceFlag = false;
                this.merchantInvoiceTypeList = [];
                this.invoiceContentTagList = [];
                this.contract = Utils.merge({}, contract);
            },
            showPriceReplyDocDlg: function () {
                let self = this;
                Vue.$showDialog({
                    title: '报价单信息',
                    width: '75%',
                    height: 700,
                    showCloseBtn: true,
                    template: '<div>' +
                        '<swb-price-reply-for-select :merchantId="merchantId" :merchantType="merchantType" :inqryMerchantId="inqryMerchantId" :inqryMerchantType="inqryMerchantType" :rowId = "rowId" ref="swb_price_reply_for_select"></swb-price-reply-for-select>' +
                        '</div>',
                    data: {
                        merchantId: null,
                        merchantType: null,
                        inqryMerchantId: null,
                        inqryMerchantType: null,
                        rowId: null
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_price_reply_for_select.getDlgResult() || {};
                        if (result.type === 'info') {
                            let checkPriceReply = result.data;
                            if (checkPriceReply.id != null) {
                                self.contract.srcWinId = checkPriceReply.id;
                                self.contract.srcName = checkPriceReply.inqryTitle;
                                self.contract.srcId = checkPriceReply.inqryVoucherId;
                                self.contract.srcFixed = true;
                                let sumAmount = 0;
                                if (self.contractType == self.servcPurch.value) {
                                    let servcList = checkPriceReply.servcList;
                                    let contractServcList = self.contract.contractServcList;
                                    contractServcList = [];
                                    if (servcList != null && servcList.length > 0) {
                                        for (var i = 0; i < servcList.length; i++) {
                                            let servc = servcList[i];
                                            let item = {};
                                            item.ssuId = servc.ssuId;
                                            item.name = servc.name;
                                            item.servcId = servc.servcId;
                                            //item.wrntPeriod = servc.wrntPeriod;
                                            item.price = ParseFloat(servc.replyPrice);
                                            item.dateStart = null;
                                            item.dateEnd = null;

                                            contractServcList.push(item);
                                        }
                                    }
                                    self.contract.servcFlag = true;
                                    self.contract.contractServcList = Utils.merge([], contractServcList);
                                }

                                self.contract.estmtAmount = sumAmount;
                                self.disabledBtn = true;
                                self.showAmtAndCot = false;

                                //获取交易规则
                                let postData = {};
                                postData.voucherId = checkPriceReply.id;
                                priceApi.getPriceReplyTermList(postData, function (result) {
                                    if (result.type == 'info') {
                                        let priceReplyTermList = result.data;
                                        if (priceReplyTermList != null && priceReplyTermList.length > 0) {
                                            self.comparedTradeRuleList = priceReplyTermList;
                                            self.tradeType = "priceReply";
                                            self.forPriceInqry = true;
                                            self.$refs.swb_create_trade_rule.getTradeRule();
                                        }
                                    }
                                });
                                return true;
                            }
                        }
                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.rowId = self.contract.srcWinId;
                            selfDlg.merchantId = self.contract.sndPartyId;
                            selfDlg.merchantType = self.contract.sndPartyType;
                            selfDlg.inqryMerchantId = self.contract.fstPartyId;
                            selfDlg.inqryMerchantType = self.contract.fstPartyType;
                        }
                    }
                });
            },
            deletePrice: function () {
                let contract = this.contract;
                contract.srcWinId = null;
                contract.srcName = null;
                contract.srcId = null;
                contract.srcFixed = null;
                contract.contractServcList = [];
                contract.estmtAmount = null;
                this.showAmtAndCot = true;
                this.disabledBtn = false;
                this.showBtn = false;
                this.comparedTradeRuleList = [];
                this.tradeType = null;
                this.forPriceInqry = null;
                this.$refs.swb_create_trade_rule.getTradeRule();
                this.contract = Utils.merge({}, contract);
            },
            monitoringData: function () {
                let theVipLevel = merchtComnApi.checkCtxMerchantVipLevel(CtrlParamCodes.VIP_VALVE_FOR_CONTRACT_PHASE_TRACK);
                if (theVipLevel != null) {
                    MsgBox.warning(theVipLevel);
                    return;
                }
                //
                let self = this;
                let type = self.contractType;
                Vue.$showDialog({
                    title: '合同数据监控',
                    width: '90%',
                    height: 700,
                    showCloseBtn: true,
                    okVisible: false,
                    cancelVisible: false,
                    template: '<div>' +
                        '<swb-contract-data-monitoring :contractId = "contractId" :contractNo = "contractNo" :contractType="type" ref="swb_contract_data_monitoring"></swb-contract-data-monitoring>' +
                        '</div>',
                    data: {
                        contractId: null,
                        contractNo: null,
                        type: null
                    },
                    methods: {},
                    okClicked: function () {

                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.contractId = self.contract.id;
                            selfDlg.contractNo = self.contract.no;
                            selfDlg.type = type;
                        }
                    }
                });
            },
            showContractRecord: function () {
                let self = this;
                let type = self.contractType;
                Vue.$showDialog({
                    title: '合同操作记录',
                    width: '90%',
                    height: '80%',
                    showCloseBtn: true,
                    okVisible: false,
                    cancelVisible: false,
                    template: '<div>' +
                        '<swb-contract-record-list :contractId = "contractId" :contractNo = "contractNo" ref="swb_contract_record_list"></swb-contract-record-list>' +
                        '</div>',
                    data: {
                        contractId: null,
                        contractNo: null
                    },
                    methods: {},
                    okClicked: function () {

                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.contractId = self.contract.id;
                            selfDlg.contractNo = self.contract.no;
                        }
                    }
                });
            },
            toTradeVoucherList: function () {
                let no = this.contract.no;
                let data = {contractNo: no};
                let hashUrl = Utils.makeUrl(SwbTradeVoucherList.path, data);
                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
            },
            toRcvVoucherList: function () {
                let id = this.contract.id;
                let srcVoucherType = getEnumInfoWith("srcVoucherType", "name", "Contract").value;
                let query = {srcVoucherType: srcVoucherType, srcVoucherId: id};
                showRouteLayer({
                    title: "收款明细",
                    query: query,
                    template: SwbRcvVoucherList
                });
            },
            kindChange(kindId) {
                if (kindId == 0) {
                    this.contract.phaseFlag = true;
                    this.contract.termsFlag = true;
                } else {
                    this.contract.phaseFlag = false;
                    this.contract.termsFlag = false;
                }
            },
            // 选择买、 卖方公司
            selectRealCom: function (isFstPartyFlag) {
                let self = this;
                let contractInfo = self.contract || {};
                let prams = {};
                if (isFstPartyFlag) { // 买方公司
                    if (Utils.isNoB(contractInfo.fstPartyId)) {
                        MsgBox.warning("请先选择商户信息");
                        return;
                    }
                    prams.merchantId = contractInfo.fstPartyId;
                    prams.merchantType = contractInfo.fstPartyType;
                }
                selectMerchantRealComDlg(prams, function (result) {
                    if (isFstPartyFlag) {
                        contractInfo.fstPartyRealId = result.realMerchantId;
                        contractInfo.fstPartyRealComId = result.id;
                        contractInfo.fstPartyRealComName = result.name;
                        contractInfo.fstPartyRealComCode = result.code;
                    } else { // 卖方公司
                        contractInfo.sndPartyRealId = result.realMerchantId;
                        contractInfo.sndPartyRealComId = result.id;
                        contractInfo.sndPartyRealComName = result.name;
                        contractInfo.sndPartyRealComCode = result.code;
                        // 获取默认收款银行卡号
                        self.getDefaultBankAcctInfo(result.id);
                    }
                    self.contract = Utils.merge({}, contractInfo);
                    if (!Utils.isNoB(self.contract.invoiceType)) {
                        // 重新获取发票抬头
                        self.getMerchantInvoiceSubjectByOnly();
                    }
                })
            },
            // 选择收款银行账号
            selectBackAcct: function () {
                let self = this;
                let contractInfo = this.contract || {};
                if (Utils.isNoB(contractInfo.sndPartyRealComId)) {
                    MsgBox.warning("请选择卖方公司");
                    return;
                }
                let params = {
                    realComId: contractInfo.sndPartyRealComId,
                    usage: 1   // 收款
                };
                selectRealComBankAcctDialog(params, function (bankAcctInfo) {
                    contractInfo.sndPartyBankName = bankAcctInfo.bankName;
                    contractInfo.sndPartyCardNo = bankAcctInfo.cardNo;
                    contractInfo.sndPartyAcctName = bankAcctInfo.acctName;
                    contractInfo.sndPartyAcctNo = bankAcctInfo.acctNo;
                    self.contract = Utils.merge({}, contractInfo);
                });
            },
            clearBackAcct: function () {
                let contractInfo = this.contract || {};
                contractInfo.sndPartyBankName = "";
                contractInfo.sndPartyCardNo = "";
                contractInfo.sndPartyAcctName = "";
                contractInfo.sndPartyAcctNo = "";
                this.contract = Utils.merge({}, contractInfo);
            },
            getDefaultBankAcctInfo: function (realComId) {
                let self = this;
                let params = {
                    realComId: realComId
                };
                let theLoad = MsgBox.loading();
                merchtComnApi.getRealComBankAcctDefaulted(params, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        let bankInfo = result.data || {};
                        //
                        let contractInfo = self.contract || {};
                        contractInfo.sndPartyBankName = bankInfo.bankName;
                        contractInfo.sndPartyCardNo = bankInfo.cardNo;
                        contractInfo.sndPartyAcctName = bankInfo.acctName;
                        contractInfo.sndPartyAcctNo = bankInfo.acctNo;
                        self.contract = Utils.merge({}, contractInfo);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 纳入结算单费用项
            changeWorkFeeType: function (value) {
                let contract = this.contract || {};
                if (contract.settleInvolvedFeeTypeIds.length <= 0) {
                    contract.settleInvolvedFeeTypeIds.push(1);
                    this.contract = Utils.merge({}, contract);
                    MsgBox.warning("至少选择一个费用项");
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/RegisterComnSellerContract.vue